import React, { useEffect, useState, useCallback } from "react";
import { Controller, useForm } from "react-hook-form";
import { useNavigate, useLocation } from "react-router-dom";
import ErrorLabel from "../../../../../component/error_label";
import { useSelector, useDispatch } from "react-redux";
import { numberWheelChange } from "../../../../../utils";
import {
  actionQuoteAdd,
  resetQuoteAdd,
  actionQuoteEdit,
  resetQuoteEdit,
  actionEmployeeNamesWithCity,
  resetEmployeeNamesWithCity,
} from "../store";
import {
  actionDownload,
  resetDownloadPolicyResponse,
} from "../../dashboard/store";
import toast from "react-hot-toast";
import "flatpickr/dist/themes/material_green.css";
import Flatpickr from "react-flatpickr";
import moment from "moment";
import Select from "react-select";
import { useDropzone } from "react-dropzone";
import Swal from "sweetalert2";
import $ from "jquery";
import {
  TOAST_DURATION,
  TOAST_ERROR_COLOR,
  TOAST_POSITION,
  TOAST_SUCCESS_COLOR,
} from "../../../../../common/app_constant";

const QuoteFrom = () => {
  const { EmployeeNamesWithCity } = useSelector((state) => ({
    ...state.formStore,
  }));

  const { downloadPolicy } = useSelector((state) => ({
    ...state.dashboardStore,
  }));
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  // const initialData = location.state?.data;
  const [initialData, setInitialData] = useState(null);
  const [employeeDocuments, setEmployeeDocuments] = useState([]);

  // call Edit and Add api
  const { QuoteAdd, QuoteEdit } = useSelector((state) => ({
    ...state.formStore,
  }));

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    setValue,
    watch,
  } = useForm({
    defaultValues: {
      ...initialData,
      usage: "Private Vehicle",
      factor: 0,
      base_tp_premium: 0,
      ll_owner_driver_pd_imt_28: 0,
      ll_to_employees_imt_29: 0,
      pa_for_unnamed_imt_16: 0,
      pa_paid_driver_imt_15: 0,
      cng_kit: 0,
      total_other_tp: 0,
      gst_perc: 18,
      current_idv_vne: 0,
      current_electrical_idv: 0,
      current_cng_idv: 0,
      expiring_cng_idv: 0,
      expiring_external_body_idv: 0,
    },
  });

  const watchTransactionDate = watch("transaction_date");
  const watchPreviousPolicyEndDate = watch("previous_policy_end_date");
  const watchPreviousPolicyStartDate = watch("previous_policy_start_date");
  const watchRenewalPan = watch("renewal_plan_final");
  const watchNewPolicyStartDate = watch("new_policy_start_date");
  const watchPolicySubType = watch("policy_sub_type");
  const watchQuoteType = watch("quote_type");
  const watchExpiringIdvVne = watch("expiring_idv_vne");
  const watchCurrentTotalIDV = watch("current_total_idv");
  const watchTariffRate = watch("tariff_rate");
  const watchPaidThrough = watch("paid_through");
  const watchTariffPremium = watch("tariff_premium");
  const watchFactor = watch("factor");
  const watchTotalTariffPremium = watch("total_tariff_premium");
  const watchDiscount = watch("discount");
  const watchCurrentYearNcb = watch("current_year_ncb");
  const watchBaseTpPremium = watch("base_tp_premium");
  const watchLlOwnerDriverPdImt28 = watch("ll_owner_driver_pd_imt_28");
  const watchLlToEmployeesImt29 = watch("ll_to_employees_imt_29");
  const watchPaForUnnamedImt16 = watch("pa_for_unnamed_imt_16");
  const watchPaPaidDriverImt15 = watch("pa_paid_driver_imt_15");
  const watchCngKit = watch("cng_kit");
  const watchTotalOtherTp = watch("total_other_tp");
  const watchAddOn1 = watch("add_on_1");
  const watchAddOn2 = watch("add_on_2");
  const watchNetOdPremium = watch("net_od_premium");
  const watchNetTpPremium = watch("net_tp_premium");
  const watchAddOn1Premium = watch("add_on_1_premium");
  const watchGoldExtra1 = watch("gold_extra_1");
  const watchGoldExtra2 = watch("gold_extra_2");
  const watchAddOn2Premium = watch("add_on_2_premium");
  const watchTotalOdTpComprehensive = watch("total_od_tp_comprehensive");
  const watchGstOdTpComprehensive = watch("gst_od_tp_comprehensive");
  const watchTotalOdTpAddOn1 = watch("total_od_tp_add_on_1");
  const watchTotalOdTpAddOn2 = watch("total_od_tp_add_on_2");
  const watchGstOdTpAddOn1 = watch("gst_od_tp_add_on_1");
  const watchGstOdTpAddOn2 = watch("gst_od_tp_add_on_2");
  const watchGSTPercentage = watch("gst_perc");
  const watchNeftReceived = watch("neft_received");

  const watchTotalPremiumWithTaxComprehensive = watch(
    "total_premium_with_tax_comprehensive"
  );
  const watchTotalPremiumWithTaxAddOn1 = watch(
    "total_premium_with_tax_add_on_1"
  );
  const watchTotalPremiumWithTaxAddOn2 = watch(
    "total_premium_with_tax_add_on_2"
  );
  const watchOdDiscount = watch("od_discount");
  const watchOdPremium = watch("od_premium");
  const watchNcbDiscount = watch("ncb_discount");
  const watchCurrentYearIdv = watch("current_year_idv");
  const watchCurrentIdvVne = watch("current_idv_vne");
  const watchCurrentElectricalIdv = watch("current_electrical_idv");
  const watchCurrentCngIdv = watch("current_cng_idv");
  const watchRenewalStatus = watch("renewal_status");
  const watchUserId = watch("user_id");
  const watchNeftCopsStatus = watch("neft_approved_cops");
  const [employeeDropdown, setEmployeeDropdown] = useState([]);
  const [watchName, setWatchName] = useState("");
  const [selectedEmpId, setSelectedEmpId] = useState(null);
  const [selectedPolicyId, setSelectedPolicyId] = useState(null);
  const [employeeDetails, setEmployeeDetails] = useState(null);
  const [policyDropdownList, setPolicyDropdownList] = useState([]);
  const [employeeListDropdown, setEmployeeListDropdown] = useState([]);
  const [detailPolicies, setDetailPolicies] = useState(null);
  const [selectedPolicyNumber, setSelectedPolicyNumber] = useState(null);
  const [loading, setLoading] = useState(false);

  const [attachment2, setAttachment2] = useState([]);
  const [document, setDocument] = useState([]);

  useEffect(() => {
    // alert (JSON.parse(localStorage.getItem("detailsData")));
    setInitialData(JSON.parse(localStorage.getItem("detailsData")));

    dispatch(
      actionEmployeeNamesWithCity({ is_name_formatted: 1, status: "ACTIVE" })
    );
  }, []);

  useEffect(() => {
    if (initialData) {
      Object.keys(initialData).forEach((key) => {
        setValue(key, initialData[key]);
      });
      setWatchName(initialData.insured_name);
      setDocument(initialData?.documents);
      setEmployeeDocuments(initialData?.neftDocuments);
      setValue("previous_policy_no", initialData?.previous_policy_id);
      setSelectedPolicyId(initialData?.previous_policy_id);
      setSelectedPolicyNumber(initialData?.previous_policy_no);
      setValue(
        "previous_policy_start_date",
        initialData.previous_policy_start_date !== null
          ? moment(initialData.previous_policy_start_date).format("DD-MM-YYYY")
          : ""
      );
      setValue(
        "previous_policy_end_date",
        initialData.previous_policy_end_date !== null
          ? moment(initialData.previous_policy_end_date).format("DD-MM-YYYY")
          : ""
      );

      setValue(
        "previous_tp_policy_start_date",
        initialData.previous_tp_policy_start_date !== null
          ? moment(initialData.previous_tp_policy_start_date).format(
            "DD-MM-YYYY"
          )
          : ""
      );
      setValue(
        "previous_tp_policy_end_date",
        initialData.previous_tp_policy_end_date !== null
          ? moment(initialData.previous_tp_policy_end_date).format("DD-MM-YYYY")
          : ""
      );

      setValue(
        "new_policy_start_date",
        initialData.new_policy_start_date !== null
          ? moment(initialData.new_policy_start_date).format("DD-MM-YYYY")
          : ""
      );
      setValue(
        "renewal_confirm_date",
        initialData.renewal_confirm_date !== null
          ? moment(initialData.renewal_confirm_date).format("DD-MM-YYYY")
          : ""
      );

      setValue(
        "neft_receive_date",
        initialData.neft_receive_date !== null
          ? moment(initialData.neft_receive_date).format("DD-MM-YYYY")
          : ""
      );
      setValue(
        "new_policy_end_date",
        initialData.new_policy_end_date !== null
          ? moment(initialData.new_policy_end_date).format("DD-MM-YYYY")
          : ""
      );

      setValue(
        "registration_date",
        initialData.registration_date !== null
          ? moment(initialData.registration_date).format("DD-MM-YYYY")
          : ""
      );
      setValue(
        "claim_date",
        initialData.claim_date !== null
          ? moment(initialData.claim_date).format("DD-MM-YYYY")
          : ""
      );

      // const dateFieldsFromInitialData = [
      //   "previous_policy_start_date",
      //   "previous_policy_end_date",
      //   "previous_tp_policy_start_date",
      //   "previous_tp_policy_end_date",
      //   "new_policy_start_date",
      //   "renewal_confirm_date",
      //   "neft_receive_date",
      //   "new_policy_end_date",
      //   "registration_date",
      //   "claim_date",
      // ];

      // dateFieldsFromInitialData.forEach((fieldName) => {
      //   if (initialData[fieldName]) {
      //     setValue(
      //       fieldName,
      //       moment(initialData[fieldName]).format("DD-MM-YYYY")
      //     );
      //   }
      // });
      setSelectedEmpId(initialData?.user_id);
      setSelectedPolicyNumber(initialData?.previous_policy_no);
      const registrationDate = moment(initialData?.registration_date);
      const currentDate = moment();
      const yearsDiff = currentDate.diff(registrationDate, "years");
      const adjustedVehicleAge = yearsDiff >= 0 ? yearsDiff : 0;
      setValue("vehicle_age", adjustedVehicleAge);
    }
  }, [initialData]);

  useEffect(() => {
    setValue("previous_policy_no", "");
  }, [watchUserId]);

  useEffect(() => {
    if (
      watchNeftCopsStatus === "Rejected" &&
      initialData?.renewal_status === "Success"
    ) {
      setValue("renewal_status", "Quote Confirm");
      setValue("neft_received", "No");
      setValue("neft_receive_date", "");
    } else if (watchNeftCopsStatus === "Approved" && initialData?.renewal_status === "Success") {

      setValue("renewal_status", initialData?.renewal_status);
      setValue("neft_received", initialData?.neft_received);
      setValue(
        'neft_receive_date',
        moment(detailPolicies?.neft_receive_date).format("DD-MM-YYYY")
      );
    }
  }, [watchNeftCopsStatus, initialData]);

  useEffect(() => {
    if (initialData === null) {
      if (watchRenewalStatus != "Pending") {
        setValue("renewal_confirm_date", new Date());
      } else {
        setValue("renewal_confirm_date", "");
        setValue("neft_receive_date", "");
        setValue("neft_received", "");
        setValue("neft_amount", "");
        setValue("neft_reference_no", "");
        setValue("neft_approved_cops", "");
        setValue("neft_cops_remarks", "");
      }
    }
  }, [watchRenewalStatus]);

  useEffect(() => {
    if (
      initialData?.previous_policy_id &&
      initialData?.previous_policy_id !== null
    ) {
      setValue("previous_policy_no", initialData.previous_policy_id);
    }
  }, [initialData]);

  useEffect(() => {
    if (selectedEmpId) {
      let idPolicy = employeeListDropdown.find(
        (item) => item.id === selectedEmpId
      );
      if (idPolicy) {
        setEmployeeDetails(idPolicy);
      }
    }
  }, [selectedEmpId]);

  useEffect(() => {
    if (employeeDetails) {
      Object.keys(employeeDetails.userPolicyList).forEach((key) => {
        setValue(key, employeeDetails.userPolicyList[key]);
        // setValue('previous_policy_no', employeeDetails.userPolicyList.previous_policy_no);
        const policyPrevNoDropdown = employeeDetails.userPolicyList?.map(
          (item, index) => ({
            label: item.policy_no,
            value: item.id,
            item: item,
          })
        );
        setPolicyDropdownList(policyPrevNoDropdown);
      });
    }
  }, [employeeDetails]);

  useEffect(() => {
    if (EmployeeNamesWithCity) {
      dispatch(resetEmployeeNamesWithCity());
      if (EmployeeNamesWithCity.status === true) {
        setEmployeeListDropdown(EmployeeNamesWithCity.data);
        const employeeListDropdown = EmployeeNamesWithCity.data?.map(
          (item, index) => ({
            label: item.full_name_with_city,
            value: item.id,
            item: item,
          })
        );
        setEmployeeDropdown(employeeListDropdown);
      } else {
        switch (EmployeeNamesWithCity.status_code) {
          case 400:
            toast.error(EmployeeNamesWithCity.message, {
              duration: TOAST_DURATION,
              position: TOAST_POSITION,
              style: {
                color: TOAST_ERROR_COLOR,
              },
            });
            localStorage.clear();
            navigate("/login", { replace: true });
            break;
          case 401:
            localStorage.clear();
            navigate("/login", { replace: true });
            break;
          default:
        }
      }
    }
  }, [EmployeeNamesWithCity]);

  useEffect(() => {
    if (policyDropdownList && policyDropdownList.length > 0) {
      const selectedPolicy = policyDropdownList.find(
        (item) => item.value === selectedPolicyId
      );
      if (selectedPolicy) {
        const policyPreviousNumber = selectedPolicy.item;
        setDetailPolicies(policyPreviousNumber);
      }
    }
    // setValue("previous_policy_no", initialData?.previous_policy_id);
  }, [policyDropdownList, selectedPolicyId]);

  useEffect(() => {
    if (policyDropdownList && policyDropdownList.length > 0) {

      setValue("previous_policy_no", initialData?.previous_policy_id);
    }
  }, [policyDropdownList]);

  useEffect(() => {
    if (selectedEmpId) {
      let idPolicy = employeeListDropdown.find(
        (item) => item.id === selectedEmpId
      );
      if (idPolicy) {
        setEmployeeDetails(idPolicy);
      }
    }
    if (employeeDetails) {
      Object.keys(employeeDetails.userPolicyList).forEach((key) => {
        setValue(key, employeeDetails.userPolicyList[key]);
        // setValue('previous_policy_no', employeeDetails.userPolicyList.previous_policy_no);
        const policyPrevNoDropdown = employeeDetails.userPolicyList?.map(
          (item, index) => ({
            label: item.policy_no,
            value: item.id,
            item: item,
          })
        );
        setPolicyDropdownList(policyPrevNoDropdown);
      });
    }
    setValue("user_id", initialData?.user_id);
  }, [employeeDropdown]);

  useEffect(() => {
    setValue("insured_name", watchName);
  }, [watchName]);

  const handleDateChange = (date) => {
    const selectedDate = moment(date);
    const expiryDate = selectedDate
      .clone()
      .add(1, "years")
      .subtract(1, "days")
      .format("DD-MM-YYYY");

    setValue("previous_policy_end_date", expiryDate);
    setValue("previous_tp_policy_end_date", expiryDate);
  };

  useEffect(() => {
    if (watchPreviousPolicyEndDate) {
      const selectedDate = moment(watchPreviousPolicyEndDate, "DD-MM-YYYY");
      const expiryDate = selectedDate
        .clone()
        .add(1, "days")
        .format("DD-MM-YYYY");

      setValue("new_policy_start_date", expiryDate);
    }
  }, [watchPreviousPolicyEndDate, setValue]);

  useEffect(() => {
    if (watchNewPolicyStartDate) {
      const selectedDate = moment(watchNewPolicyStartDate, "DD-MM-YYYY");
      const expiryDate = selectedDate
        .clone()
        .add(1, "years")
        .subtract(1, "days")
        .format("DD-MM-YYYY");

      setValue("new_policy_end_date", expiryDate);
    }
  }, [watchNewPolicyStartDate, setValue]);

  useEffect(() => {
    if (detailPolicies) {
      Object.keys(detailPolicies).forEach((key) => {
        if (
          key !== "product_name" &&
          key !== "previous_policy_no" &&
          key !== "user_id"
        ) {
          setValue(key, detailPolicies[key]);
        }
        setValue("previous_add_on_value", detailPolicies?.current_plan);
        setValue("cc", detailPolicies?.cubic_capacity);
        setValue("model", detailPolicies?.vehicle_model);
        setValue("make", detailPolicies?.vehicle_make);
        setValue("variant", detailPolicies?.vehicle_variant);
        setValue(
          "registration_number",
          detailPolicies?.vehicle_no && detailPolicies?.vehicle_no !== null
            ? detailPolicies?.vehicle_no
            : initialData?.registration_number
        );
        setValue("rto_location", detailPolicies?.rto_details);
        setValue("policy_sub_type", detailPolicies?.policy_type);
        setValue("segment", detailPolicies?.vehicle_type);
        setValue(
          "expiring_ncb",
          initialData?.expiring_ncb != null
            ? initialData?.expiring_ncb
            : detailPolicies?.ncb_current_year
        );
      });
      setValue(
        "previous_policy_start_date",
        moment(detailPolicies?.policy_start_date).format("DD-MM-YYYY")
      );
      setValue(
        "previous_policy_end_date",
        moment(detailPolicies?.policy_expiry_date).format("DD-MM-YYYY")
      );
      setValue(
        "previous_tp_policy_start_date",
        moment(detailPolicies?.tp_start_date).format("DD-MM-YYYY")
      );
      setValue(
        "previous_tp_policy_end_date",
        moment(detailPolicies?.tp_expiry_date).format("DD-MM-YYYY")
      );
      setValue("chassis_no", detailPolicies?.chassis);
      setValue("expiring_idv_vne", detailPolicies?.sum_insured);
      setValue("current_year_idv", null);
      setValue(
        "paid_through",
        initialData?.paid_through && initialData?.paid_through !== null
          ? initialData.paid_through
          : null
      );

      const dateFieldsFromPolicies = [
        // "renewal_confirm_date",
        "neft_receive_date",
        "registration_date",
        "claim_date",
      ];
      dateFieldsFromPolicies.forEach((fieldName) => {
        if (detailPolicies[fieldName]) {
          setValue(
            fieldName,
            moment(detailPolicies[fieldName]).format("DD-MM-YYYY")
          );
        }
      });

      const registrationDate = moment(detailPolicies?.registration_date);
      const currentDate = moment();
      const yearsDiff = currentDate.diff(registrationDate, "years");
      const adjustedVehicleAge = yearsDiff >= 0 ? yearsDiff : 0;
      setValue("vehicle_age", adjustedVehicleAge);
    }
  }, [detailPolicies]);

  useEffect(() => {
    if (watchExpiringIdvVne && watchExpiringIdvVne !== null) {
      const calculatedValue = Math.round(Number(watchExpiringIdvVne) * 0.9);
      setValue("current_year_idv", calculatedValue);
    }
  }, [watchExpiringIdvVne]);

  // useEffect(() => {
  //   const totalIdv =
  //     Number(watchCurrentYearIdv) +
  //     Number(watchCurrentIdvVne) +
  //     Number(watchCurrentElectricalIdv) +
  //     Number(watchCurrentCngIdv);
  //   setValue("current_total_idv", Number(totalIdv).toFixed(2));
  // }, [
  //   watchCurrentYearIdv,
  //   watchCurrentIdvVne,
  //   watchCurrentElectricalIdv,
  //   watchCurrentCngIdv,
  // ]);

  // useEffect(() => {
  //   // Set the value of tariff_premium
  //   if (
  //     watchCurrentTotalIDV &&
  //     watchCurrentTotalIDV !== null &&
  //     watchTariffRate &&
  //     watchTariffRate !== null
  //   ) {
  //     setValue(
  //       "tariff_premium",
  //       (
  //         (Number(watchCurrentTotalIDV) * Number(watchTariffRate)) /
  //         100
  //       ).toFixed(4)
  //     );
  //   }
  // }, [watchCurrentTotalIDV, watchTariffRate]);

  // useEffect(() => {
  //   // Set the value of total_tariff_premium
  //   if (watchTariffPremium !== null && watchFactor !== null) {
  //     setValue(
  //       "total_tariff_premium",
  //       (Number(watchTariffPremium) + Number(watchFactor)).toFixed(4)
  //     );
  //   }
  // }, [watchTariffPremium, watchFactor]);

  // useEffect(() => {
  //   if (watchTotalTariffPremium !== null && watchDiscount !== null) {
  //     setValue(
  //       "od_discount",
  //       (
  //         (Number(watchTotalTariffPremium) * Number(watchDiscount)) /
  //         100
  //       ).toFixed(4)
  //     );
  //   }
  // }, [watchTotalTariffPremium, watchDiscount]);

  // useEffect(() => {
  //   if (watchTotalTariffPremium !== null && watchOdDiscount !== null) {
  //     const od_premium = (
  //       Number(watchTotalTariffPremium) - Number(watchOdDiscount)
  //     ).toFixed(4);
  //     setValue("od_premium", od_premium);
  //   }
  // }, [watchTotalTariffPremium, watchOdDiscount]);

  // useEffect(() => {
  //   if (watchOdPremium !== null && watchCurrentYearNcb !== null) {
  //     const ncb_discount =
  //       (Number(watchOdPremium) * Number(watchCurrentYearNcb)) / 100;
  //     setValue("ncb_discount", Number(ncb_discount).toFixed(4));
  //   }
  // }, [watchOdPremium, watchCurrentYearNcb]);

  // useEffect(() => {
  //   if (watchOdPremium !== null && watchNcbDiscount !== null) {
  //     const net_od_premium = (
  //       Number(watchOdPremium) - Number(watchNcbDiscount)
  //     ).toFixed(4);
  //     setValue("net_od_premium", Number(net_od_premium).toFixed(2));
  //   }
  // }, [watchOdPremium, watchNcbDiscount]);

  // useEffect(() => {
  //   if (
  //     watchBaseTpPremium !== null &&
  //     watchLlOwnerDriverPdImt28 !== null &&
  //     watchLlToEmployeesImt29 !== null &&
  //     watchPaForUnnamedImt16 !== null &&
  //     watchPaPaidDriverImt15 !== null &&
  //     watchCngKit !== null &&
  //     watchTotalOtherTp !== null
  //   ) {
  //     setValue(
  //       "net_tp_premium",
  //       Number(watchBaseTpPremium) +
  //         Number(watchLlOwnerDriverPdImt28) +
  //         Number(watchLlToEmployeesImt29) +
  //         Number(watchPaForUnnamedImt16) +
  //         Number(watchPaPaidDriverImt15) +
  //         Number(watchCngKit) +
  //         Number(watchTotalOtherTp)
  //     );
  //   }
  // }, [
  //   watchBaseTpPremium,
  //   watchLlOwnerDriverPdImt28,
  //   watchLlToEmployeesImt29,
  //   watchPaForUnnamedImt16,
  //   watchPaPaidDriverImt15,
  //   watchCngKit,
  //   watchTotalOtherTp,
  // ]);

  // useEffect(() => {
  //   if (watchAddOn1 !== null && watchCurrentTotalIDV !== null) {
  //     setValue(
  //       "add_on_1_premium",
  //       ((Number(watchCurrentTotalIDV) * Number(watchAddOn1)) / 100).toFixed(2)
  //     );
  //   }
  // }, [watchAddOn1, watchCurrentTotalIDV]);

  // useEffect(() => {
  //   if (watchAddOn2 !== null && watchCurrentTotalIDV !== null) {
  //     setValue(
  //       "add_on_2_premium",
  //       ((Number(watchCurrentTotalIDV) * Number(watchAddOn2)) / 100).toFixed(2)
  //     );
  //   }
  // }, [watchAddOn2, watchCurrentTotalIDV]);

  // useEffect(() => {
  //   if (watchNetOdPremium !== null && watchNetTpPremium !== null) {
  //     const total_od_tp_comprehensive = (
  //       Number(watchNetOdPremium) + Number(watchNetTpPremium)
  //     ).toFixed(4);
  //     setValue(
  //       "total_od_tp_comprehensive",
  //       Number(total_od_tp_comprehensive).toFixed(4)
  //     );
  //   }
  // }, [watchNetOdPremium, watchNetTpPremium]);

  // useEffect(() => {
  //   if (
  //     watchNetOdPremium !== null &&
  //     watchNetTpPremium !== null &&
  //     watchAddOn1Premium !== null &&
  //     watchGoldExtra1 !== null
  //   ) {
  //     const total_od_tp_add_on_1 =
  //       Number(watchNetOdPremium) +
  //       Number(watchNetTpPremium) +
  //       Number(watchAddOn1Premium) +
  //       Number(watchGoldExtra1);
  //     setValue("total_od_tp_add_on_1", Number(total_od_tp_add_on_1).toFixed(4));
  //   }
  // }, [
  //   watchNetOdPremium,
  //   watchNetTpPremium,
  //   watchAddOn1Premium,
  //   watchGoldExtra1,
  // ]);

  // useEffect(() => {
  //   if (
  //     watchNetOdPremium !== null &&
  //     watchNetTpPremium !== null &&
  //     watchAddOn2Premium !== null &&
  //     watchGoldExtra2 !== null
  //   ) {
  //     const total_od_tp_add_on_2 =
  //       Number(watchNetOdPremium) +
  //       Number(watchNetTpPremium) +
  //       Number(watchAddOn2Premium) +
  //       Number(watchGoldExtra2);
  //     setValue("total_od_tp_add_on_2", Number(total_od_tp_add_on_2).toFixed(4));
  //   }
  // }, [
  //   watchNetOdPremium,
  //   watchNetTpPremium,
  //   watchAddOn2Premium,
  //   watchGoldExtra2,
  // ]);

  // useEffect(() => {
  //   if (watchGSTPercentage !== null) {
  //     setValue(
  //       "gst_od_tp_comprehensive",
  //       (
  //         (Number(watchTotalOdTpComprehensive) * Number(watchGSTPercentage)) /
  //         100
  //       ).toFixed(4)
  //     );
  //     setValue(
  //       "gst_od_tp_add_on_1",
  //       (
  //         Number(watchTotalOdTpAddOn1) *
  //         (Number(watchGSTPercentage) / 100)
  //       ).toFixed(4)
  //     );
  //     setValue(
  //       "gst_od_tp_add_on_2",
  //       (
  //         Number(watchTotalOdTpAddOn2) *
  //         (Number(watchGSTPercentage) / 100)
  //       ).toFixed(4)
  //     );
  //   }
  // }, [
  //   watchGSTPercentage,
  //   watchTotalOdTpComprehensive,
  //   watchTotalOdTpAddOn1,
  //   watchTotalOdTpAddOn2,
  // ]);

  // useEffect(() => {
  //   if (
  //     watchTotalOdTpComprehensive !== null &&
  //     watchGstOdTpComprehensive !== null
  //   ) {
  //     const total_premium_with_tax_comprehensive =
  //       Number(watchTotalOdTpComprehensive) + Number(watchGstOdTpComprehensive);
  //     setValue(
  //       "total_premium_with_tax_comprehensive",
  //       Number(total_premium_with_tax_comprehensive).toFixed(4)
  //     );
  //   }
  // }, [watchTotalOdTpComprehensive, watchGstOdTpComprehensive]);

  // useEffect(() => {
  //   if (watchTotalOdTpAddOn1 !== null && watchGstOdTpAddOn1 !== null) {
  //     const total_premium_with_tax_add_on_1 =
  //       Number(watchTotalOdTpAddOn1) + Number(watchGstOdTpAddOn1);
  //     setValue(
  //       "total_premium_with_tax_add_on_1",
  //       Number(total_premium_with_tax_add_on_1).toFixed(4)
  //     );
  //   }
  // }, [watchTotalOdTpAddOn1, watchGstOdTpAddOn1]);

  // useEffect(() => {
  //   if (watchTotalOdTpAddOn2 !== null && watchGstOdTpAddOn2 !== null) {
  //     const total_premium_with_tax_add_on_2 =
  //       Number(watchTotalOdTpAddOn2) + Number(watchGstOdTpAddOn2);
  //     setValue(
  //       "total_premium_with_tax_add_on_2",
  //       Number(total_premium_with_tax_add_on_2).toFixed(4)
  //     );
  //   }
  // }, [watchTotalOdTpAddOn2, watchGstOdTpAddOn2]);

  // useEffect(() => {
  //   let renewal_final_amt = 0;
  //   if (watchRenewalPan === "TP Only") {
  //     renewal_final_amt =
  //       Number(watchNetTpPremium) +
  //       Number(watchNetTpPremium) * (Number(watchGSTPercentage) / 100);
  //   } else if (watchRenewalPan === "Comprehensive") {
  //     renewal_final_amt = Number(watchTotalPremiumWithTaxComprehensive);
  //   } else if (watchRenewalPan === "Add_On_1") {
  //     renewal_final_amt = Number(watchTotalPremiumWithTaxAddOn1);
  //   } else if (watchRenewalPan === "Add_On_2") {
  //     renewal_final_amt = Number(watchTotalPremiumWithTaxAddOn2);
  //   }
  //   !isNaN(renewal_final_amt) &&
  //     setValue("renewal_final_amt", Number(renewal_final_amt).toFixed(2));
  // }, [
  //   watchNetTpPremium,
  //   watchGSTPercentage,
  //   watchTotalPremiumWithTaxComprehensive,
  //   watchTotalPremiumWithTaxAddOn1,
  //   watchTotalPremiumWithTaxAddOn2,
  //   watchRenewalPan,
  // ]);

  useEffect(() => {
    if (QuoteAdd) {
      dispatch(resetQuoteAdd());
      $("#add_edit_policy").prop("disabled", false);
      if (QuoteAdd.status === true) {
        setLoading(false);
        toast.success(QuoteAdd.message, {
          duration: TOAST_DURATION,
          position: TOAST_POSITION,
          style: {
            color: TOAST_SUCCESS_COLOR,
          },
        });
        navigate(-1);
      } else {
        setLoading(false);
        toast.error(QuoteAdd.message, {
          duration: TOAST_DURATION,
          position: TOAST_POSITION,
          style: {},
        });
      }
    }
  }, [QuoteAdd]);

  useEffect(() => {
    if (downloadPolicy !== null) {
      dispatch(resetDownloadPolicyResponse());
      if (downloadPolicy.status === true) {
        if (downloadPolicy.status === true && Array.isArray(downloadPolicy.data.urls)) {
          downloadPolicy.data.urls.forEach(item => {
            if (item.url) {
              window.open(item.url, '_blank');
            }
          });
        }
      } else {
        switch (downloadPolicy.status_code) {
          case 400:
            toast.error(downloadPolicy.message, {
              duration: TOAST_DURATION,
              position: TOAST_POSITION,
              style: {
                color: TOAST_ERROR_COLOR,
              },
            });
            localStorage.clear();
            navigate("/login", { replace: true });
            break;
          case 401:
            localStorage.clear();
            navigate("/login", { replace: true });
            break;
          default:
        }
      }
    }
  }, [downloadPolicy]);

  useEffect(() => {
    if (QuoteEdit) {
      dispatch(resetQuoteEdit());
      $("#add_edit_policy").prop("disabled", false);
      if (QuoteEdit.status === true) {
        setLoading(false);
        toast.success(QuoteEdit.message, {
          duration: TOAST_DURATION,
          position: TOAST_POSITION,
          style: {
            color: TOAST_SUCCESS_COLOR,
          },
        });
        window.close();
      } else {
        setLoading(false);
        toast.error("Error in Updating Quote", {
          duration: TOAST_DURATION,
          position: TOAST_POSITION,
          style: {},
        });
      }
    }
  }, [QuoteEdit]);

  const onDrop2 = useCallback((acceptedFiles) => {
    $("#document-required").addClass("d-none");
    if (attachment2.length < 3) {
      setAttachment2([...attachment2, ...acceptedFiles]);
    } else {
    }
  });
  const {
    getRootProps: getRootProps2,
    getInputProps: getInputProps2,
    fileRejections: fileRejections2,
  } = useDropzone({
      accept: {
        accept: [
          ".pdf",
          ".doc",
          ".docx",
          ".jpeg",
          ".jpg",
          ".png",
          ".xls",
          ".xlsx"
        ]
      },
    multiple: true,
    maxFiles: 3,
    maxSize: 5 * 1024 * 1024, // 5 MB file size limit
    onDrop: onDrop2,
  });
  
   const fileRejectionItems2 = fileRejections2.map(({ file, errors }) => (
    <div key={file.path} className="text-danger mt-2 small">
      <strong>{file.name}</strong> - {(file.size / 1024 / 1024).toFixed(2)} MB
      {errors.map((e, index) => (
        <div key={index}> {e.message}</div>
      ))}
    </div>
  ));

  const removeFile2 = (file) => () => {
    const newFiles = [...attachment2];
    newFiles.splice(newFiles.indexOf(file), 1);
    setAttachment2(newFiles);
  };
  const removeAll2 = () => {
    setAttachment2([]);
  };
  const thumbs2 = attachment2?.map((file) => (
    <>
      <div className="card mt-3" key={file.name}>
        <div className="card-body d-flex justify-content-between">
          <span className="my-auto"> {file.name} </span>
          <button
            type="reset"
            className="btn btn-sm btn-primary"
            onClick={removeFile2(file)}
          >
            X
          </button>
        </div>
      </div>
    </>
  ));

  const onSubmit = (data) => {
    data.id = initialData?.id;
    data.cc = String(data.cc);
    data.previous_add_on_value = data.previous_add_on_value;
    data.product_name = "PRIVATE CAR";
    data.previous_policy_id = selectedPolicyId;
    data.previous_policy_no = selectedPolicyNumber;
    data.user_id = selectedEmpId;

    Object.keys(data).forEach((key) => {
      if (
        data[key] == undefined ||
        data[key] == null ||
        data[key] == "Invalid date"
      ) {
        delete data[key];
      }
    });
    const dateFields = [
      "new_policy_start_date",
      "new_policy_end_date",
      "previous_policy_start_date",
      "previous_policy_end_date",
      "previous_tp_policy_start_date",
      "previous_tp_policy_end_date",
      "registration_date",
      "neft_receive_date",
      "renewal_confirm_date",
      "claim_date",
    ];
    dateFields.forEach((fieldName) => {
      if (data[fieldName]) {
        data[fieldName] = moment(data[fieldName], "DD-MM-YYYY").format(
          "YYYY-MM-DD"
        );
      }
    });
    delete data.owner_name;
    Object.keys(data).forEach((key) => {
      if (!isNaN(key)) {
        delete data[key];
      }
    });

    if (!data.registration_number) {
      delete data.registration_number;
    }

    let files = [];

    if (attachment2.length > 0) {
      attachment2.forEach((objImage, index) => {
        files.push({
          name: "file",
          value: objImage,
        });
      });
    }

    var input = { ...data };
    input.user_id = selectedEmpId;

    if (initialData) {
      $("#add-edit-quote-loader").removeClass("hidden");
      $("#add_edit_quote").prop("disabled", true);
      dispatch(
        actionQuoteEdit({
          input,
          files,
        })
      );
      setLoading(true);
    } else {
      if (
        watchNeftReceived === "Yes" &&
        !attachment2?.length &&
        watchPaidThrough === "Self Paid"
      ) {
        $("#upload_document_first").removeClass("d-none");
      } else {
        $("#upload_document_first").addClass("d-none");
        $("#add-edit-quote-loader").removeClass("hidden");
        $("#add_edit_quote").prop("disabled", true);
        dispatch(
          actionQuoteAdd({
            input,
            files,
          })
        );
        setLoading(true);
      }
    }
  };

  return (
    <>
      <section className="pb-5">
        <div className="card mb-5 mt-6">
          <div className="card-header bg-primary  d-flex justify-content-between">
            <h6 className="mb-0">{initialData ? "Edit" : "Add"} Quote</h6>
            {
              !initialData &&
              <h6
                className="text-white mb-0 cursor-pointer"
                onClick={(event) => {
                  event.preventDefault();
                  navigate(-1);
                }}
              >
                {" "}
                Back
              </h6>
            }
          </div>
          <div className="card-body">
            <form
              noValidate
              autoComplete="Off"
              onSubmit={handleSubmit(onSubmit)}
            >
              <div className="form-body">
                <div className="row mb-3">
                  {/* Vehical Details */}
                  <div className="col-12 border-bottom mb-2">
                    <h6 className="text-primary">Vehicle Details</h6>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    {/* If Quote Type = renewal the previous policy no filed come up */}
                    <div className="form-group">
                      <label htmlFor="quote_type" className="label-control">
                        Quote Type <span className="text-danger"></span>
                      </label>
                      <select
                        className="form-control"
                        id="quote_type"
                        name="quote_type"
                        placeholder="Select..."
                        {...register("quote_type", {
                          required: "This is required.",
                        })}
                      >
                        <option value="Rollover">Rollover </option>
                        <option value="Renewal">Renewal</option>
                        <option value="New">New</option>
                        <option value="Personal">Personal</option>
                      </select>
                      {errors.quote_type && (
                        <ErrorLabel message={errors.quote_type?.message} />
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label htmlFor="product_name" className="label-control">
                        Product Name <span className="text-danger">* </span>
                      </label>
                      <input
                        className="form-control"
                        id="product_name"
                        name="product_name"
                        value="PRIVATE CAR"
                        readOnly
                      />
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label htmlFor="user_id" className="label-control">
                        Employee Name
                        <span className="text-danger"></span>
                      </label>
                      <Controller
                        className="form-control"
                        rules={{ required: "This is required." }}
                        control={control}
                        defaultValue=""
                        name="user_id"
                        render={({ field }) => {
                          return (
                            <Select
                              {...field}
                              placeholder="Select"
                              menuPlacement={"bottom"}
                              isMulti={false}
                              isClearable={true}
                              hideSelectedOptions={false}
                              maxMenuHeight={200}
                              name="name"
                              options={employeeDropdown}
                              value={employeeDropdown.find(
                                (c) => c.value === field.value
                              )}
                              onChange={(selectedOptions) => {
                                field.onChange(selectedOptions);
                                const selectedLabel = selectedOptions.label;
                                setSelectedEmpId(selectedOptions.value);
                                setWatchName(selectedOptions.item.full_name);
                              }}
                            />
                          );
                        }}
                      />
                      {errors.user_id && (
                        <ErrorLabel message={errors.user_id?.message} />
                      )}
                    </div>
                  </div>

                  {/* if Quote = New then hide this filed */}
                  {watchQuoteType != "New" && (
                    <>
                      <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label
                            htmlFor="previous_policy_no"
                            className="label-control"
                          >
                            Previous Policy No{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <Controller
                            className="form-control"
                            rules={{
                              required:
                                !watchQuoteType === "New" &&
                                "This is required.",
                            }}
                            control={control}
                            name="previous_policy_no"
                            render={({ field }) => {
                              return (
                                <Select
                                  {...field}
                                  placeholder="Select"
                                  menuPlacement={"bottom"}
                                  isMulti={false}
                                  isClearable={true}
                                  hideSelectedOptions={false}
                                  maxMenuHeight={200}
                                  id="previous_policy_no"
                                  name="previous_policy_no"
                                  readOnly={watchQuoteType === "New"}
                                  options={policyDropdownList}
                                  value={
                                    field.value && field.value !== null
                                      ? policyDropdownList.find(
                                        (c) => c.value === field.value
                                      )
                                      : ""
                                  }
                                  onChange={(selectedOptions) => {
                                    field.onChange(selectedOptions);
                                    setSelectedPolicyId(selectedOptions.value);
                                    setSelectedPolicyNumber(
                                      selectedOptions.label
                                    );
                                  }}
                                />
                              );
                            }}
                          />
                          {errors.previous_policy_no && (
                            <ErrorLabel
                              message={errors.previous_policy_no?.message}
                            />
                          )}
                        </div>
                      </div>
                    </>
                  )}
                  {/* END */}

                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label htmlFor="renewal_month" className="label-control">
                        Renewal Month{" "}
                        <span className="text-danger">
                          *
                          {/* prev policy Eepiry month or non mandetory or user
                          input */}
                        </span>
                      </label>
                      <input
                        type="month"
                        className="form-control"
                        id="renewal_month"
                        defaultValue={moment().format("YYYY-MM")}
                        name="renewal_month"
                        placeholder="select month"
                        {...register("renewal_month", {
                          required: "This is required.",
                        })}
                      />
                      {errors.renewal_month && (
                        <ErrorLabel message={errors.renewal_month?.message} />
                      )}
                    </div>
                  </div>

                  {/* <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label htmlFor="owner_name" className="label-control">
                        Owner Name{" "}
                        <span className="text-danger">Not Required in FE</span>
                      </label>
                      <input
                        className="form-control"
                        id="owner_name"
                        name="owner_name"
                        {...register("owner_name", {
                          required: "This is required.",
                        })}
                      />
                      {errors.owner_name && (
                        <ErrorLabel message={errors.owner_name?.message} />
                      )}
                    </div>
                  </div> */}

                  {/* <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label
                        htmlFor="address_with_pin_code"
                        className="label-control"
                      >
                        Address with Pin Code{" "}
                        <span className="text-danger">Not Required in FE</span>
                        <span className="text-danger"></span>
                      </label>
                      <input
                        className="form-control"
                        id="address_with_pin_code"
                        name="address_with_pin_code"
                        {...register("address_with_pin_code", {
                          required: "This is required.",
                        })}
                      />
                      {errors.address_with_pin_code && (
                        <ErrorLabel
                          message={errors.address_with_pin_code?.message}
                        />
                      )}
                    </div>
                  </div> */}

                  {/* <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label htmlFor="email_id" className="label-control">
                        Email ID{" "}
                        <span className="text-danger">Not Required in FE</span>
                      </label>
                      <input
                        className="form-control"
                        id="email_id"
                        name="email_id"
                        {...register("email_id", {
                          required: "This is required.",
                        })}
                      />
                      {errors.email_id && (
                        <ErrorLabel message={errors.email_id?.message} />
                      )}
                    </div>
                  </div> */}
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      {/* (Customer Name) */}
                      <label className="label-control">
                        Insured Name
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        className="form-control"
                        id="insured_name"
                        name="insured_name"
                        {...register("insured_name", {
                          required: "This is required",
                        })}
                      />
                      {errors.insured_name && (
                        <ErrorLabel message={errors.insured_name?.message} />
                      )}
                    </div>
                  </div>

                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label
                        htmlFor="insured_pancard_no"
                        className="label-control"
                      >
                        Insured PAN Card No
                        <span className="text-danger"></span>
                      </label>
                      <input
                        className="form-control"
                        id="insured_pancard_no"
                        name="insured_pancard_no"
                        {...register("insured_pancard_no", {
                          pattern: {
                            value: /^[A-Z]{5}[0-9]{4}[A-Z]$/,
                            message: "Please enter a valid PAN card number.",
                          },
                        })}
                      />
                      {errors.insured_pancard_no && (
                        <ErrorLabel
                          message={errors.insured_pancard_no?.message}
                        />
                      )}
                    </div>
                  </div>

                  {/* <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label htmlFor="gstin_number" className="label-control">
                        GSTIN Number{" "}
                        <span className="text-danger">
                          Not required in FE ?
                        </span>
                      </label>
                      <input
                        className="form-control"
                        id="gstin_number"
                        name="gstin_number"
                        {...register("gstin_number", {
                          required: "This is required.",
                        })}
                      />
                      {errors.gstin_number && (
                        <ErrorLabel message={errors.gstin_number?.message} />
                      )}
                    </div>
                  </div> */}

                  {/* <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label htmlFor="producer_code" className="label-control">
                        Producer Code{" "}
                        <span className="text-danger">
                          Not required in FE ?
                        </span>
                      </label>
                      <input
                        className="form-control"
                        id="producer_code"
                        name="producer_code"
                        {...register("producer_code", {
                          required: "This is required.",
                        })}
                      />
                      {errors.producer_code && (
                        <ErrorLabel message={errors.producer_code?.message} />
                      )}
                    </div>
                  </div> */}

                  {/* <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label htmlFor="branch_code" className="label-control">
                        Branch Code{" "}
                        <span className="text-danger">
                          Not required in FE ?
                        </span>
                      </label>
                      <input
                        className="form-control"
                        id="branch_code"
                        name="branch_code"
                        {...register("branch_code", {
                          required: "This is required.",
                        })}
                      />
                      {errors.branch_code && (
                        <ErrorLabel message={errors.branch_code?.message} />
                      )}
                    </div>
                  </div> */}
                  {/* Policy Detials  */}
                  <div className="col-12 border-bottom mb-2">
                    <h6 className="text-primary">Policy Details </h6>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label
                        htmlFor="policy_sub_type"
                        className="label-control"
                      >
                        Policy Sub Type <span className="text-danger"></span>
                      </label>
                      <select
                        className="form-control"
                        id="policy_sub_type"
                        name="policy_sub_type"
                        placeholder="Select..."
                        {...register("policy_sub_type", {
                          required: "This is required.",
                        })}
                      >
                        <option value="Package Policy">Package Policy</option>
                        <option value="Standalone OD">Standalone OD</option>
                        <option value="TP Only">TP Only </option>
                        <option value="Others">Others</option>
                        {
                          watchQuoteType === 'New' && <option value="Bundle plan (1+3)">Bundle plan (1+3)</option>
                        }
                      </select>
                      {errors.policy_sub_type && (
                        <ErrorLabel message={errors.policy_sub_type?.message} />
                      )}
                    </div>
                  </div>
                  {/* Conditionally render Previous Policy Number field -
                   If Quote Type = renewal the previous policy no filed come up */}
                  {watchQuoteType != "New" && (
                    <>
                      <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label
                            htmlFor="previous_insurer"
                            className="label-control"
                          >
                            Previous Insurer{" "}
                            <span className="text-danger"></span>
                          </label>
                          <input
                            className="form-control"
                            id="previous_insurer"
                            name="previous_insurer"
                            {...register("previous_insurer", {
                              required: "This is required.",
                            })}
                            defaultValue="TATA AIG GIC LTD"
                            readOnly={watchQuoteType === "New" ? true : false}
                          />
                          {errors.previous_insurer && (
                            <ErrorLabel
                              message={errors.previous_insurer?.message}
                            />
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label
                            htmlFor="previous_policy_start_date"
                            className="label-control"
                          >
                            Previous Policy Start Date
                            <span className="text-danger">
                              {/* Non-Editable if Quote Type is "New". For others
                              editable, auto picked from employee policy table -
                              policy no mapping pending & need to change in
                              flatficker */}
                              *
                            </span>
                          </label>
                          <Controller
                            name="previous_policy_start_date"
                            id="previous_policy_start_date"
                            control={control}
                            render={({ field }) => (
                              <Flatpickr
                                {...field}
                                onChange={(value) => {
                                  var date = new Date(value).toISOString();
                                  handleDateChange(date);
                                  setValue(
                                    "previous_policy_start_date",
                                    moment(date).format("DD-MM-YYYY")
                                  );
                                  setValue(
                                    "previous_tp_policy_start_date",
                                    moment(date).format("DD-MM-YYYY")
                                  );
                                }}
                                id="disabled-picker"
                                className="form-control"
                                options={{
                                  dateFormat: "d-m-Y",
                                  enableTime: false,
                                }}
                              />
                            )}
                            rules={{
                              required: "This is required.",
                            }}
                          />
                          {errors.previous_policy_start_date && (
                            <ErrorLabel
                              message={
                                errors.previous_policy_start_date?.message
                              }
                            />
                          )}
                        </div>
                      </div>

                      <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label
                            htmlFor="previous_policy_end_date"
                            className="label-control"
                          >
                            Previous Policy End Date
                            <span className="text-danger">
                              {/* auto picked from employee policy table - policy no
                              mapping pending & need to change in flatficker  */}
                              *
                            </span>
                          </label>
                          <Controller
                            name="previous_policy_end_date"
                            id="previous_policy_end_date"
                            control={control}
                            render={({ field }) => (
                              <Flatpickr
                                {...field}
                                onChange={(value) => {
                                  var date = new Date(value).toISOString();
                                  setValue(
                                    "previous_policy_end_date",
                                    moment(date).format("DD-MM-YYYY")
                                  );
                                  setValue(
                                    "previous_tp_policy_end_date",
                                    moment(date).format("DD-MM-YYYY")
                                  );
                                }}
                                id="disabled-picker"
                                className="form-control"
                                options={{
                                  dateFormat: "d-m-Y",
                                  enableTime: false,
                                }}
                              />
                            )}
                            rules={{
                              required: "This is required.",
                            }}
                          />
                          {errors.previous_policy_end_date && (
                            <ErrorLabel
                              message={errors.previous_policy_end_date?.message}
                            />
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label
                            htmlFor="previous_tp_policy_start_date"
                            className="label-control"
                          >
                            Previous TP Policy Start Date{" "}
                            <span className="text-danger"></span>
                          </label>
                          <Controller
                            name="previous_tp_policy_start_date"
                            id="previous_tp_policy_start_date"
                            control={control}
                            render={({ field }) => (
                              <Flatpickr
                                {...field}
                                onChange={(value) => {
                                  var date = new Date(value).toISOString();
                                  setValue(
                                    "previous_tp_policy_start_date",
                                    moment(date).format("DD-MM-YYYY")
                                  );
                                }}
                                id="disabled-picker"
                                className="form-control"
                                options={{
                                  dateFormat: "d-m-Y",
                                  enableTime: false,
                                }}
                              />
                            )}
                            rules={{
                              required: "This is required.",
                            }}
                          />
                          {errors.previous_tp_policy_start_date && (
                            <ErrorLabel
                              message={
                                errors.previous_tp_policy_start_date?.message
                              }
                            />
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label
                            htmlFor="previous_tp_policy_end_date"
                            className="label-control"
                          >
                            Previous TP Policy End Date{" "}
                            <span className="text-danger"></span>
                          </label>
                          <Controller
                            name="previous_tp_policy_end_date"
                            id="previous_tp_policy_end_date"
                            control={control}
                            render={({ field }) => (
                              <Flatpickr
                                {...field}
                                onChange={(value) => {
                                  var date = new Date(value).toISOString();
                                  setValue(
                                    "previous_tp_policy_end_date",
                                    moment(date).format("DD-MM-YYYY")
                                  );
                                }}
                                id="disabled-picker"
                                className="form-control"
                                options={{
                                  dateFormat: "d-m-Y",
                                  enableTime: false,
                                }}
                              />
                            )}
                            rules={{
                              required: "This is required.",
                            }}
                          />
                          {errors.previous_tp_policy_end_date && (
                            <ErrorLabel
                              message={
                                errors.previous_tp_policy_end_date?.message
                              }
                            />
                          )}
                        </div>
                      </div>
                    </>
                  )}
                  {/* ----------------------------------END */}

                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label
                        htmlFor="new_policy_start_date"
                        className="label-control"
                      >
                        New Policy Start Date{" "}
                        <span className="text-danger">{`${watchQuoteType === "New" &&
                            watchRenewalStatus === "Success"
                            ? "*"
                            : ""
                          }`}</span>
                      </label>
                      <Controller
                        name="new_policy_start_date"
                        id="new_policy_start_date"
                        control={control}
                        render={({ field }) => (
                          <Flatpickr
                            {...field}
                            onChange={(value) => {
                              var date = new Date(value).toISOString();
                              setValue(
                                "new_policy_start_date",
                                moment(date).format("DD-MM-YYYY")
                              );
                              setValue(
                                "new_policy_end_date",
                                moment(date)
                                  .add(1, "years")
                                  .subtract(1, "days")
                                  .format("DD-MM-YYYY")
                              );
                            }}
                            id="disabled-picker"
                            className="form-control"
                            options={{
                              dateFormat: "d-m-Y",
                              enableTime: false,
                            }}
                          />
                        )}
                        rules={{
                          required:
                            watchQuoteType === "New" &&
                              watchRenewalStatus === "Success"
                              ? "This is required."
                              : false,
                        }}
                      />
                      {errors.new_policy_start_date && (
                        <ErrorLabel
                          message={errors.new_policy_start_date?.message}
                        />
                      )}
                    </div>
                  </div>

                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label
                        htmlFor="new_policy_end_date"
                        className="label-control"
                      >
                        New Policy End Date{" "}
                        <span className="text-danger">{`${watchQuoteType === "New" &&
                            watchRenewalStatus === "Success"
                            ? "*"
                            : ""
                          }`}</span>
                      </label>
                      <Controller
                        name="new_policy_end_date"
                        id="new_policy_end_date"
                        control={control}
                        render={({ field }) => (
                          <Flatpickr
                            {...field}
                            onChange={(value) => {
                              var date = new Date(value).toISOString();
                              setValue(
                                "new_policy_end_date",
                                moment(date).format("DD-MM-YYYY")
                              );
                            }}
                            id="disabled-picker"
                            className="form-control"
                            options={{
                              dateFormat: "d-m-Y",
                              enableTime: false,
                            }}
                          />
                        )}
                        rules={{
                          required:
                            watchQuoteType === "New" &&
                              watchRenewalStatus === "Success"
                              ? "This is required."
                              : false,
                        }}
                      />
                      {errors.new_policy_end_date && (
                        <ErrorLabel
                          message={errors.new_policy_end_date?.message}
                        />
                      )}
                    </div>
                  </div>

                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label htmlFor="rto_location" className="label-control">
                        RTO Location <span className="text-danger">*</span>
                      </label>
                      <input
                        className="form-control"
                        id="rto_location"
                        name="rto_location"
                        {...register("rto_location", {
                          required: "This is required.",
                        })}
                      />
                      {errors.rto_location && (
                        <ErrorLabel message={errors.rto_location?.message} />
                      )}
                    </div>
                  </div>

                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label htmlFor="usage" className="label-control">
                        Usage <span className="text-danger">*</span>
                      </label>
                      <input
                        className="form-control"
                        id="usage"
                        name="usage"
                        {...register("usage", {
                          required: "This is required.",
                        })}
                      />
                      {errors.usage && (
                        <ErrorLabel message={errors.usage?.message} />
                      )}
                    </div>
                  </div>

                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label htmlFor="segment" className="label-control">
                        Segment <span className="text-danger">*</span>
                      </label>
                      <select
                        className="form-control"
                        id="segment"
                        name="segment"
                        {...register("segment", {
                          required: "This is required.",
                        })}
                      >
                        <option value=""></option>
                        <option value="MPV SU">MPV SU</option>
                        <option value="UHE">UHE</option>
                        <option value="HE">HE</option>
                        <option value="Compact">Compact</option>
                        <option value="Mid size">Mid size</option>
                        <option value="Mini">Mini</option>
                      </select>
                      {errors.segment && (
                        <ErrorLabel message={errors.segment?.message} />
                      )}
                    </div>
                  </div>

                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label className="label-control">
                        Vehicle Make&nbsp;
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        className="form-control"
                        id="make"
                        name="make"
                        {...register("make", {
                          required: "This is required.",
                          pattern: {
                            value: /^[a-zA-Z0-9 ,/,\\,_,#,.,-]*$/,
                            message: "Please enter valid policy number",
                          },
                        })}
                      />
                      {errors.make && (
                        <ErrorLabel message={errors.make?.message} />
                      )}
                    </div>
                  </div>

                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label className="label-control">
                        Vehicle Model&nbsp;
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        className="form-control"
                        id="model"
                        name="model"
                        {...register("model", {
                          required: "This is required.",
                          pattern: {
                            value: /^[a-zA-Z0-9 ,/,\\,_,#,.,-]*$/,
                            message: "Please enter valid model",
                          },
                        })}
                      />
                      {errors.model && (
                        <ErrorLabel message={errors.model?.message} />
                      )}
                    </div>
                  </div>

                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label className="label-control">Vehicle Variant</label>
                      <input
                        className="form-control"
                        id="variant"
                        name="variant"
                        {...register("variant", {
                          pattern: {
                            value: /^[a-zA-Z0-9 ,/,\\,_,#,.,-]*$/,
                            message: "Please enter valid variant",
                          },
                        })}
                      />
                    </div>
                  </div>

                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label className="label-control">
                        Vehicle Engine No&nbsp;<span className="danger">*</span>
                      </label>
                      <input
                        className="form-control"
                        id="engine_no"
                        name="engine_no"
                        maxlength={20}
                        {...register("engine_no", {
                          required:
                            "Engine Number must be of minimum 5-digits",
                          pattern: {
                            value: /^[a-zA-Z0-9]*$/,
                            message:
                              "Engine Number can only contain alphabets and numbers.",
                          },
                          minLength: {
                            value: 5,
                            message:
                              "Engine Number must be of minimum 5-digits",
                          },
                          maxLength: {
                            value: 25,
                            message:
                              "Engine Number must be of minimum 25-digits",
                          },
                        })}
                        onChange={(e) => {
                          e.target.value = e.target.value.toUpperCase();
                        }}
                      />
                      {errors.engine_no && (
                        <ErrorLabel message={errors.engine_no?.message} />
                      )}
                    </div>
                  </div>

                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label className="label-control">
                        Chassis Number&nbsp;<span className="danger">*</span>
                      </label>
                      <input
                        className="form-control"
                        id="chassis_no"
                        name="chassis_no"
                        maxlength={17}
                        {...register("chassis_no", {
                          required: "This is required.",
                          pattern: {
                            value: /^[a-zA-Z0-9]*$/,
                            message:
                              "Chassis Number can only contain alphabets and numbers.",
                          },
                          minLength: {
                            value: 17,
                            message:
                              "Chassis Number must be of minimum 17-digits",
                          },
                          maxLength: {
                            value: 17,
                            message:
                              "Chassis Number must be of minimum 17-digits",
                          },
                        })}
                        onChange={(e) => {
                          e.target.value = e.target.value.toUpperCase();
                        }}
                      />
                      {errors.chassis_no && (
                        <ErrorLabel message={errors.chassis_no?.message} />
                      )}
                    </div>
                  </div>

                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label className="label-control">
                        Fuel Type
                        <span className="text-danger">*</span>
                      </label>
                      <select
                        className="form-control"
                        id="fuel_type"
                        name="fuel_type"
                        placeholder="Select.."
                        {...register("fuel_type", {
                          required: "This is required.",
                        })}
                      >
                        <option value="Petrol">Petrol</option>
                        <option value="CNG">CNG</option>
                        <option value="Diesel">Diesel</option>
                        <option value="ELECTRIC">ELECTRIC</option>
                        <option value="HYBRID">HYBRID </option>
                      </select>
                      {errors.fuel_type && (
                        <ErrorLabel message={errors.fuel_type?.message} />
                      )}
                    </div>
                  </div>

                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label className="label-control">
                        Seating Capacity
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        type="number"
                        onFocus={numberWheelChange}
                        className="form-control"
                        id="seating_capacity"
                        name="seating_capacity"
                        {...register("seating_capacity", {
                          required: "This is required.",
                          pattern: {
                            value: /^(10|[0-9])$/,
                            message:
                              "Please enter a valid number between 0 and 10.",
                          },
                        })}
                      />
                      {errors.seating_capacity && (
                        <ErrorLabel
                          message={errors.seating_capacity?.message}
                        />
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label className="label-control">
                        Cubic capacity (CC)
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        type="number"
                        onFocus={numberWheelChange}
                        className="form-control"
                        id="cc"
                        name="cc"
                        {...register("cc", {
                          required: "This is required.",
                          min: {
                            value: 50,
                            message:
                              "Please enter a value greater than or equal to 50.",
                          },
                          pattern: {
                            value: /^[0-9]\d*$/,
                            message:
                              "Please enter a valid non-decimal number greater than 50.",
                          },
                        })}
                      />
                      {errors.cc && <ErrorLabel message={errors.cc?.message} />}
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label className="label-control">
                        Vehicle Number(Reg. No.)
                        <span className="text-danger"></span>
                      </label>
                      <input
                        className="form-control"
                        id="registration_number"
                        name="registration_number"
                        {...register("registration_number", {
                          required:
                            watchQuoteType == "New"
                              ? false
                              : "This is required.",
                          pattern: {
                            value: /^[a-zA-Z0-9]{10}$/i,
                            message: "Please enter a valid vehicle number",
                          },
                        })}
                        onChange={(e) => {
                          const inputValue = e.target.value.toUpperCase();
                          setValue("registration_number", inputValue, {
                            shouldValidate: true,
                          });
                        }}
                      />
                      {errors.registration_number && (
                        <ErrorLabel
                          message={errors.registration_number?.message}
                        />
                      )}
                    </div>
                  </div>

                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label
                        htmlFor="year_of_manufacturing"
                        className="label-control"
                      >
                        Year of Manufacturing{" "}
                        <span className="text-danger">{`${watchQuoteType === "New" ? "*" : ""
                          }`}</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="year_of_manufacturing"
                        name="year_of_manufacturing"
                        {...register("year_of_manufacturing", {
                          required:
                            watchQuoteType === "New" && "This is required.",
                        })}
                      />
                      {errors.year_of_manufacturing && (
                        <ErrorLabel
                          message={errors.year_of_manufacturing?.message}
                        />
                      )}
                    </div>
                  </div>

                  <div className="col-12 col-md-3 mb-3">
                    <div class="form-group has-search">
                      <label for="registration_date" class="form-label">
                        Registration Date{" "}
                        <span className="text-danger">
                          {`${watchQuoteType !== "New" ? "*" : ""} `}
                          {/* for new its non madatory */}{" "}
                        </span>
                      </label>
                      <span class="fa fa-calendar form-control-feedback"></span>
                      <Controller
                        name="registration_date"
                        id="registration_date"
                        control={control}
                        rules={{
                          required:
                            watchQuoteType !== "New"
                              ? "This is required."
                              : false,
                        }}
                        render={({ field }) => (
                          <Flatpickr
                            {...field}
                            onChange={(value) => {
                              var date = new Date(value).toISOString();
                              setValue(
                                "registration_date",
                                moment(date).format("DD-MM-YYYY")
                              );
                              const selectedDate = moment(
                                value[0],
                                "DD-MM-YYYY"
                              );
                              setValue(
                                "registration_date",
                                selectedDate.format("DD-MM-YYYY")
                              );
                              const currentDate = moment();
                              const yearsDiff = currentDate.diff(
                                selectedDate,
                                "years"
                              );
                              const adjustedVehicleAge =
                                yearsDiff >= 0 ? yearsDiff : 0;
                              setValue("vehicle_age", adjustedVehicleAge);
                            }}
                            id="disabled-picker"
                            className="form-control"
                            options={{
                              dateFormat: "d-m-Y",
                              enableTime: false,
                              maxDate: moment(watchNewPolicyStartDate)
                                .add(180, "days")
                                .toDate(),
                            }}
                          />
                        )}
                      />
                      {errors.registration_date && (
                        <ErrorLabel
                          message={errors.registration_date?.message}
                        />
                      )}
                    </div>
                  </div>

                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label htmlFor="vehicle_age" className="label-control">
                        Vehicle Age <span className="text-danger"></span>
                      </label>
                      <input
                        type="number"
                        onFocus={numberWheelChange}
                        className="form-control"
                        id="vehicle_age"
                        name="vehicle_age"
                        {...register("vehicle_age", {
                          required: "This is required.",
                          pattern: {
                            value: /^[0-9]\d*$/,
                            message: "Please enter a valid non-decimal number",
                          },
                        })}
                      />
                      {errors.vehicle_age && (
                        <ErrorLabel message={errors.vehicle_age?.message} />
                      )}
                    </div>
                  </div>

                  <div className="col-12 col-md-3 mb-3">
                    <div className="form-group">
                      <label
                        htmlFor="nominee_name_age_relationship"
                        className="label-control"
                      >
                        Nominee Name/Age/Relationship{" "}
                        <span className="text-danger"></span>
                      </label>
                      <input
                        className="form-control"
                        id="nominee_name_age_relationship"
                        name="nominee_name_age_relationship"
                        {...register("nominee_name_age_relationship", {})}
                      />
                      {errors.nominee_name_age_relationship && (
                        <ErrorLabel
                          message={
                            errors.nominee_name_age_relationship?.message
                          }
                        />
                      )}
                    </div>
                  </div>
                  {/* IDV Details   */}

                  <div className="col-4 mb-2">
                    <div className="col-12 border-bottom mb-2">
                      <h6 className="text-primary">IDV Details</h6>
                    </div>
                    <div className="row">
                      {/* expiring idv */}
                      {watchQuoteType != "New" && (
                        <div className="col">
                          <div className="card h-100">
                            <div className="card-body ">
                              {watchQuoteType != "New" && (
                                <div className="col-12 mb-3">
                                  <div className="form-group">
                                    <label
                                      htmlFor="claim_date"
                                      className="label-control "
                                    >
                                      Claim Date{" "}
                                      <span className="text-danger"></span>
                                    </label>
                                    <Controller
                                      name="claim_date"
                                      id="claim_date"
                                      control={control}
                                      render={({ field }) => (
                                        <Flatpickr
                                          {...field}
                                          onChange={(value) => {
                                            var date = new Date(
                                              value
                                            ).toISOString();
                                            setValue(
                                              "claim_date",
                                              moment(date).format("DD-MM-YYYY")
                                            );
                                          }}
                                          id="disabled-picker"
                                          className="form-control"
                                          options={{
                                            dateFormat: "d-m-Y",
                                            enableTime: false,
                                          }}
                                        />
                                      )}
                                    />
                                    {errors.claim_date && (
                                      <ErrorLabel
                                        message={errors.claim_date?.message}
                                      />
                                    )}
                                  </div>
                                </div>
                              )}

                              {watchQuoteType != "New" && (
                                <div className="col-12 mb-3">
                                  <div className="form-group">
                                    <label
                                      htmlFor="expiring_ncb"
                                      className="label-control "
                                    >
                                      Expiring NCB{" "}
                                      <span className="text-danger"></span>
                                    </label>
                                    <select
                                      className="form-control"
                                      id="expiring_ncb"
                                      name="expiring_ncb"
                                      {...register("expiring_ncb", {})}
                                    >
                                      <option value="">Expiring NCB</option>
                                      <option value="0">0%</option>
                                      <option value="20">20%</option>
                                      <option value="25">25%</option>
                                      <option value="35">35%</option>
                                      <option value="45">45%</option>
                                      <option value="50">50%</option>
                                      <option value="60">60%</option>
                                    </select>
                                    {errors.expiring_ncb && (
                                      <ErrorLabel
                                        message={errors.expiring_ncb?.message}
                                      />
                                    )}
                                  </div>
                                </div>
                              )}

                              {watchQuoteType != "New" && (
                                <div className="col-12 mb-3">
                                  <div className="form-group">
                                    <label
                                      htmlFor="expiring_idv_vne"
                                      className="label-control "
                                    >
                                      Expiring IDV (Vehicle + Non electrical)
                                      <span className="text-danger"></span>
                                    </label>
                                    <input
                                      type="number"
                                      onFocus={numberWheelChange}
                                      className="form-control"
                                      id="expiring_idv_vne"
                                      readOnly={
                                        watchQuoteType === "New" ? true : false
                                      }
                                      name="expiring_idv_vne"
                                      {...register("expiring_idv_vne", {
                                        required: "This is required.",
                                      })}
                                    />
                                    {errors.expiring_idv_vne && (
                                      <ErrorLabel
                                        message={
                                          errors.expiring_idv_vne?.message
                                        }
                                      />
                                    )}
                                  </div>
                                </div>
                              )}

                              {watchQuoteType != "New" && (
                                <div className="col-12 mb-3">
                                  <div className="form-group">
                                    <label
                                      htmlFor="expiring_external_body_idv"
                                      className="label-control "
                                    >
                                      Expiring External Body IDV{" "}
                                      <span className="text-danger"></span>
                                    </label>
                                    <input
                                      className="form-control"
                                      id="expiring_external_body_idv"
                                      name="expiring_external_body_idv"
                                      type="number"
                                      onFocus={numberWheelChange}
                                      {...register(
                                        "expiring_external_body_idv",
                                        {
                                          pattern: {
                                            value: /^[0-9]\d*$/,
                                            message:
                                              "Please enter a valid non-decimal number",
                                          },
                                        }
                                      )}
                                    />
                                    {errors.expiring_external_body_idv && (
                                      <ErrorLabel
                                        message={
                                          errors.expiring_external_body_idv
                                            ?.message
                                        }
                                      />
                                    )}
                                  </div>
                                </div>
                              )}

                              {watchQuoteType != "New" && (
                                <div className="col-12 mb-3">
                                  <div className="form-group">
                                    <label
                                      htmlFor="expiring_cng_idv"
                                      className="label-control "
                                    >
                                      Expiring CNG IDV{" "}
                                      <span className="text-danger"></span>
                                    </label>
                                    <input
                                      className="form-control"
                                      id="expiring_cng_idv"
                                      name="expiring_cng_idv"
                                      type="number"
                                      onFocus={numberWheelChange}
                                      {...register("expiring_cng_idv", {
                                        pattern: {
                                          value: /^[0-9]\d*$/,
                                          message:
                                            "Please enter a valid non-decimal number",
                                        },
                                      })}
                                    />
                                    {errors.expiring_cng_idv && (
                                      <ErrorLabel
                                        message={
                                          errors.expiring_cng_idv?.message
                                        }
                                      />
                                    )}
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      )}
                      {/* end expiring idv */}
                      <div className="col">
                        <div className="card h-100">
                          <div className="card-body">
                            <div className="col-12 mb-3">
                              <div className="form-group">
                                <label
                                  htmlFor="current_year_idv"
                                  className="label-control "
                                >
                                  Current Year IDV{" "}
                                  <span className="text-danger"></span>
                                </label>
                                <input
                                  type="number"
                                  onFocus={numberWheelChange}
                                  className="form-control"
                                  id="current_year_idv"
                                  name="current_year_idv"
                                  {...register("current_year_idv", {
                                    required: "This is required.",
                                  })}
                                />
                                {errors.current_year_idv && (
                                  <ErrorLabel
                                    message={errors.current_year_idv?.message}
                                  />
                                )}
                              </div>
                            </div>

                            <div className="col-12 mb-3">
                              <div className="form-group">
                                <label
                                  htmlFor="current_electrical_idv"
                                  className="label-control "
                                >
                                  Current Electrical IDV{" "}
                                  <span className="text-danger"></span>
                                </label>
                                <input
                                  type="number"
                                  onFocus={numberWheelChange}
                                  className="form-control"
                                  id="current_electrical_idv"
                                  name="current_electrical_idv"
                                  {...register("current_electrical_idv", {})}
                                />
                                {errors.current_electrical_idv && (
                                  <ErrorLabel
                                    message={
                                      errors.current_electrical_idv?.message
                                    }
                                  />
                                )}
                              </div>
                            </div>

                            <div className="col-12 mb-3">
                              <div className="form-group">
                                <label
                                  htmlFor="current_idv_vne"
                                  className="label-control "
                                >
                                  Current IDV VNE{" "}
                                  <span className="text-danger"></span>
                                </label>
                                <input
                                  type="number"
                                  onFocus={numberWheelChange}
                                  className="form-control"
                                  id="current_idv_vne"
                                  name="current_idv_vne"
                                  {...register("current_idv_vne", {})}
                                />
                                {errors.current_idv_vne && (
                                  <ErrorLabel
                                    message={errors.current_idv_vne?.message}
                                  />
                                )}
                              </div>
                            </div>

                            <div className="col-12 mb-3">
                              <div className="form-group">
                                <label
                                  htmlFor="current_cng_idv"
                                  className="label-control "
                                >
                                  Current CNG IDV{" "}
                                  <span className="text-danger"></span>
                                </label>
                                <input
                                  type="number"
                                  onFocus={numberWheelChange}
                                  className="form-control"
                                  id="current_cng_idv"
                                  name="current_cng_idv"
                                  {...register("current_cng_idv", {
                                    required: "This is required.",
                                  })}
                                />
                                {errors.current_cng_idv && (
                                  <ErrorLabel
                                    message={errors.current_cng_idv?.message}
                                  />
                                )}
                              </div>
                            </div>

                            <div className="col-12 mb-3">
                              <div className="form-group">
                                <label
                                  htmlFor="current_total_idv"
                                  className="label-control fw-bold"
                                >
                                  Current Total IDV
                                </label>
                                <input
                                  type="number"
                                  onFocus={numberWheelChange}
                                  className="form-control"
                                  id="current_total_idv"
                                  name="current_total_idv"
                                  {...register("current_total_idv", {
                                    required: "This is required.",
                                  })}
                                />
                                {errors.current_total_idv && (
                                  <ErrorLabel
                                    message={errors.current_total_idv?.message}
                                  />
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* END IDV Details */}
                  <div className="col-8 mb-2 h-100">
                    <div className="col-12 border-bottom mb-2">
                      <h6 className="text-primary">Tariff Calculation </h6>
                    </div>
                    <div className="row">
                      <div className="col-12 col-md-3">
                        <div className="card h-100">
                          <div className="card-body">
                            <div className="col-12 mb-3">
                              <div className="form-group">
                                <label
                                  htmlFor="tariff_rate"
                                  className="label-control "
                                >
                                  Tariff Rate %{" "}
                                  <span className="text-danger"></span>
                                </label>
                                <input
                                  type="number"
                                  onFocus={numberWheelChange}
                                  className="form-control"
                                  id="tariff_rate"
                                  name="tariff_rate"
                                  {...register("tariff_rate", {
                                    required: "This is required.",
                                  })}
                                />
                                {errors.tariff_rate && (
                                  <ErrorLabel
                                    message={errors.tariff_rate?.message}
                                  />
                                )}
                              </div>
                            </div>

                            <div className="col-12 mb-3">
                              <div className="form-group">
                                <label
                                  htmlFor="tariff_premium"
                                  className="label-control"
                                >
                                  Tariff Premium{" "}
                                  <span className="text-danger"></span>
                                </label>
                                <input
                                  type="number"
                                  onFocus={numberWheelChange}
                                  className="form-control"
                                  id="tariff_premium"
                                  name="tariff_premium"
                                  {...register("tariff_premium", {
                                    required: "This is required.",
                                  })}
                                />
                                {errors.tariff_premium && (
                                  <ErrorLabel
                                    message={errors.tariff_premium?.message}
                                  />
                                )}
                              </div>
                            </div>
                            <div className="col-12 mb-3">
                              <div className="form-group">
                                <label
                                  htmlFor="factor"
                                  className="label-control"
                                >
                                  Factor <span className="text-danger"></span>
                                </label>
                                <input
                                  type="number"
                                  onFocus={numberWheelChange}
                                  className="form-control"
                                  id="factor"
                                  name="factor"
                                  {...register("factor", {})}
                                />
                                {errors.factor && (
                                  <ErrorLabel
                                    message={errors.factor?.message}
                                  />
                                )}
                              </div>
                            </div>

                            <div className="col-12 mb-3">
                              <div className="form-group">
                                <label
                                  htmlFor="total_tariff_premium"
                                  className="label-control"
                                >
                                  Total Tariff Premium{" "}
                                  <span className="text-danger"></span>
                                </label>
                                <input
                                  type="number"
                                  onFocus={numberWheelChange}
                                  className="form-control"
                                  id="total_tariff_premium"
                                  name="total_tariff_premium"
                                  {...register("total_tariff_premium", {
                                    required: "This is required.",
                                  })}
                                />
                                {errors.total_tariff_premium && (
                                  <ErrorLabel
                                    message={
                                      errors.total_tariff_premium?.message
                                    }
                                  />
                                )}
                              </div>
                            </div>
                            <div className="col-12 mb-3">
                              <div className="form-group">
                                <label
                                  htmlFor="current_year_ncb"
                                  className="label-control"
                                >
                                  Current Year NCB{" "}
                                  <span className="text-danger"></span>
                                </label>
                                <select
                                  className="form-control"
                                  id="current_year_ncb"
                                  name="current_year_ncb"
                                  {...register("current_year_ncb", {
                                    required: "This is required.",
                                  })}
                                >
                                  <option value="">Current NCB</option>
                                  <option value="0">0%</option>
                                  <option value="20">20%</option>
                                  <option value="25">25%</option>
                                  <option value="35">35%</option>
                                  <option value="45">45%</option>
                                  <option value="50">50%</option>
                                  <option value="60">60%</option>
                                </select>
                                {errors.current_year_ncb && (
                                  <ErrorLabel
                                    message={errors.current_year_ncb?.message}
                                  />
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-md-3">
                        <div className="card h-100">
                          <div className="card-body">
                            <div className="col-12 mb-3">
                              <div className="form-group">
                                <label
                                  htmlFor="discount"
                                  className="label-control"
                                >
                                  Discount <span className="text-danger"></span>
                                </label>
                                <input
                                  type="number"
                                  onFocus={numberWheelChange}
                                  className="form-control"
                                  id="discount"
                                  name="discount"
                                  defaultValue={85}
                                  {...register("discount", {
                                    required: "This is required.",
                                  })}
                                />
                                {errors.discount && (
                                  <ErrorLabel
                                    message={errors.discount?.message}
                                  />
                                )}
                              </div>
                            </div>

                            <div className="col-12 mb-3">
                              <div className="form-group">
                                <label
                                  htmlFor="od_discount"
                                  className="label-control"
                                >
                                  OD Discount{" "}
                                  <span className="text-danger"></span>
                                </label>
                                <input
                                  type="number"
                                  onFocus={numberWheelChange}
                                  className="form-control"
                                  id="od_discount"
                                  name="od_discount"
                                  {...register("od_discount", {
                                    required: "This is required.",
                                  })}
                                />
                                {errors.od_discount && (
                                  <ErrorLabel
                                    message={errors.od_discount?.message}
                                  />
                                )}
                              </div>
                            </div>

                            <div className="col-12 mb-3">
                              <div className="form-group">
                                <label
                                  htmlFor="od_premium"
                                  className="label-control"
                                >
                                  OD Premium{" "}
                                  <span className="text-danger"></span>
                                </label>
                                <input
                                  type="number"
                                  onFocus={numberWheelChange}
                                  className="form-control"
                                  id="od_premium"
                                  name="od_premium"
                                  {...register("od_premium", {
                                    required: "This is required.",
                                  })}
                                />
                                {errors.od_premium && (
                                  <ErrorLabel
                                    message={errors.od_premium?.message}
                                  />
                                )}
                              </div>
                            </div>

                            <div className="col-12 mb-3">
                              <div className="form-group">
                                <label
                                  htmlFor="ncb_discount"
                                  className="label-control"
                                >
                                  NCB Discount{" "}
                                  <span className="text-danger"></span>
                                </label>
                                <input
                                  type="number"
                                  onFocus={numberWheelChange}
                                  className="form-control"
                                  id="ncb_discount"
                                  name="ncb_discount"
                                  {...register("ncb_discount", {
                                    required: "This is required.",
                                  })}
                                />
                                {errors.ncb_discount && (
                                  <ErrorLabel
                                    message={errors.ncb_discount?.message}
                                  />
                                )}
                              </div>
                            </div>

                            <div className="col-12 mb-3">
                              <div className="form-group">
                                <label
                                  htmlFor="net_od_premium"
                                  className="label-control"
                                >
                                  Net OD Premium{" "}
                                  <span className="text-danger"></span>
                                </label>
                                <input
                                  type="number"
                                  onFocus={numberWheelChange}
                                  className="form-control"
                                  id="net_od_premium"
                                  name="net_od_premium"
                                  {...register("net_od_premium", {
                                    required: "This is required.",
                                  })}
                                />
                                {errors.net_od_premium && (
                                  <ErrorLabel
                                    message={errors.net_od_premium?.message}
                                  />
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-md-6">
                        <div className=" card h-100">
                          <div className="card-body row">
                            <div className="col-12 col-md-6 mb-3">
                              <div className="form-group">
                                <label
                                  htmlFor="base_tp_premium"
                                  className="label-control"
                                >
                                  Base TP Premium{" "}
                                  <span className="text-danger"></span>
                                </label>
                                <input
                                  type="number"
                                  onFocus={numberWheelChange}
                                  className="form-control"
                                  id="base_tp_premium"
                                  name="base_tp_premium"
                                  {...register("base_tp_premium", {
                                    required:
                                      watchPolicySubType === "TP Only"
                                        ? "This is required."
                                        : false,
                                  })}
                                />
                                {errors.base_tp_premium && (
                                  <ErrorLabel
                                    message={errors.base_tp_premium?.message}
                                  />
                                )}
                              </div>
                            </div>

                            <div className="col-12 col-md-6 mb-3">
                              <div className="form-group">
                                <label
                                  htmlFor="ll_owner_driver_pd_imt_28"
                                  className="label-control"
                                >
                                  LL Owner Driver PD IMT 28{" "}
                                  <span className="text-danger"></span>
                                </label>
                                <input
                                  type="number"
                                  onFocus={numberWheelChange}
                                  className="form-control"
                                  id="ll_owner_driver_pd_imt_28"
                                  name="ll_owner_driver_pd_imt_28"
                                  {...register("ll_owner_driver_pd_imt_28", {})}
                                />
                                {errors.ll_owner_driver_pd_imt_28 && (
                                  <ErrorLabel
                                    message={
                                      errors.ll_owner_driver_pd_imt_28?.message
                                    }
                                  />
                                )}
                              </div>
                            </div>

                            <div className="col-12 col-md-6 mb-3">
                              <div className="form-group">
                                <label
                                  htmlFor="ll_to_employees_imt_29"
                                  className="label-control"
                                >
                                  LL to Employees IMT 29{" "}
                                  <span className="text-danger"></span>
                                </label>
                                <input
                                  type="number"
                                  onFocus={numberWheelChange}
                                  className="form-control"
                                  id="ll_to_employees_imt_29"
                                  name="ll_to_employees_imt_29"
                                  {...register("ll_to_employees_imt_29", {})}
                                />
                                {errors.ll_to_employees_imt_29 && (
                                  <ErrorLabel
                                    message={
                                      errors.ll_to_employees_imt_29?.message
                                    }
                                  />
                                )}
                              </div>
                            </div>

                            <div className="col-12 col-md-6 mb-3">
                              <div className="form-group">
                                <label
                                  htmlFor="pa_for_unnamed_imt_16"
                                  className="label-control"
                                >
                                  PA for Unnamed IMT 16{" "}
                                  <span className="text-danger"></span>
                                </label>
                                <input
                                  type="number"
                                  onFocus={numberWheelChange}
                                  className="form-control"
                                  id="pa_for_unnamed_imt_16"
                                  name="pa_for_unnamed_imt_16"
                                  {...register("pa_for_unnamed_imt_16", {})}
                                />
                                {errors.pa_for_unnamed_imt_16 && (
                                  <ErrorLabel
                                    message={
                                      errors.pa_for_unnamed_imt_16?.message
                                    }
                                  />
                                )}
                              </div>
                            </div>

                            <div className="col-12 col-md-6 mb-3">
                              <div className="form-group">
                                <label
                                  htmlFor="pa_paid_driver_imt_15"
                                  className="label-control"
                                >
                                  PA Paid Driver IMT 15{" "}
                                  <span className="text-danger"></span>
                                </label>
                                <input
                                  type="number"
                                  onFocus={numberWheelChange}
                                  className="form-control"
                                  id="pa_paid_driver_imt_15"
                                  name="pa_paid_driver_imt_15"
                                  {...register("pa_paid_driver_imt_15", {})}
                                />
                                {errors.pa_paid_driver_imt_15 && (
                                  <ErrorLabel
                                    message={
                                      errors.pa_paid_driver_imt_15?.message
                                    }
                                  />
                                )}
                              </div>
                            </div>

                            <div className="col-12 col-md-6 mb-3">
                              <div className="form-group">
                                <label
                                  htmlFor="cng_kit"
                                  className="label-control"
                                >
                                  CNG Kit <span className="text-danger"></span>
                                </label>
                                <input
                                  type="number"
                                  onFocus={numberWheelChange}
                                  className="form-control"
                                  id="cng_kit"
                                  name="cng_kit"
                                  {...register("cng_kit", {})}
                                />
                                {errors.cng_kit && (
                                  <ErrorLabel
                                    message={errors.cng_kit?.message}
                                  />
                                )}
                              </div>
                            </div>

                            <div className="col-12  mb-3">
                              <div className="form-group">
                                <label
                                  htmlFor="total_other_tp"
                                  className="label-control"
                                >
                                  Total Other TP{" "}
                                  <span className="text-danger"></span>
                                </label>
                                <input
                                  type="number"
                                  onFocus={numberWheelChange}
                                  className="form-control"
                                  id="total_other_tp"
                                  name="total_other_tp"
                                  {...register("total_other_tp", {})}
                                />
                                {errors.total_other_tp && (
                                  <ErrorLabel
                                    message={errors.total_other_tp?.message}
                                  />
                                )}
                              </div>
                            </div>

                            <div className="col-12 mb-3">
                              <div className="form-group">
                                <label
                                  htmlFor="net_tp_premium"
                                  className="label-control"
                                >
                                  Net TP Premium{" "}
                                  <span className="text-danger"></span>
                                </label>
                                <input
                                  type="number"
                                  onFocus={numberWheelChange}
                                  className="form-control"
                                  id="net_tp_premium"
                                  name="net_tp_premium"
                                  {...register("net_tp_premium", {
                                    required: "This is required.",
                                    validate: (value) => {
                                      if (watchPolicySubType === 'Bundle plan (1+3)' && parseFloat(value) <= 0 && watchRenewalStatus === "Success") {
                                        return 'For Bundle plan (1+3), TP Premium must be greater than 0.'
                                      } else {
                                        return true
                                      }
                                    }
                                  })}
                                />
                                {errors.net_tp_premium && (
                                  <ErrorLabel
                                    message={errors.net_tp_premium?.message}
                                  />
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-6 mt-3 mb-2 ">
                    <div className="col-12 border-bottom mb-2">
                      <h6 className="text-primary">Add On Calculation</h6>
                    </div>
                    <div className="row">
                      <div className="col-12 col-md-4">
                        <div className="card">
                          <div className="card-body">
                            <div className="col-12 mb-3">
                              <div className="form-group">
                                <label
                                  htmlFor="total_od_tp_comprehensive"
                                  className="label-control"
                                >
                                  {/* ( Total OD TP Comprehensive) */}
                                  Net OD + TP Premium
                                  <span className="text-danger"></span>
                                </label>
                                <input
                                  type="number"
                                  onFocus={numberWheelChange}
                                  className="form-control"
                                  id="total_od_tp_comprehensive"
                                  name="total_od_tp_comprehensive"
                                  {...register("total_od_tp_comprehensive", {
                                    required: "This is required.",
                                  })}
                                />
                                {errors.total_od_tp_comprehensive && (
                                  <ErrorLabel
                                    message={
                                      errors.total_od_tp_comprehensive?.message
                                    }
                                  />
                                )}
                              </div>
                            </div>
                            <div className="col-12 mb-3">
                              <div className="form-group">
                                <label
                                  htmlFor="gst_perc"
                                  className="label-control"
                                >
                                  GST %<span className="text-danger">*</span>
                                </label>
                                <input
                                  type="number"
                                  onFocus={numberWheelChange}
                                  className="form-control"
                                  id="gst_perc"
                                  name="gst_perc"
                                  {...register("gst_perc", {
                                    required: "This is required.",
                                  })}
                                />
                                {errors.gst_perc && (
                                  <ErrorLabel
                                    message={errors.gst_perc?.message}
                                  />
                                )}
                              </div>
                            </div>

                            <div className="col-12 mb-3">
                              <div className="form-group">
                                <label
                                  htmlFor="gst_od_tp_comprehensive"
                                  className="label-control"
                                >
                                  GST Amt
                                  {/* (GST OD TP Comprehensive) */}
                                  <span className="text-danger"></span>
                                </label>
                                <input
                                  type="number"
                                  onFocus={numberWheelChange}
                                  className="form-control"
                                  id="gst_od_tp_comprehensive"
                                  name="gst_od_tp_comprehensive"
                                  {...register("gst_od_tp_comprehensive", {
                                    required: "This is required.",
                                  })}
                                />
                                {errors.gst_od_tp_comprehensive && (
                                  <ErrorLabel
                                    message={
                                      errors.gst_od_tp_comprehensive?.message
                                    }
                                  />
                                )}
                              </div>
                            </div>

                            <div className="col-12 mb-3">
                              <div className="form-group">
                                <label
                                  htmlFor="total_premium_with_tax_comprehensive"
                                  className="label-control"
                                >
                                  {/* (Total Premium with Tax Comprehensive) */}
                                  Gross OD + TP Premium
                                  <span className="text-danger"></span>
                                </label>
                                <input
                                  type="number"
                                  onFocus={numberWheelChange}
                                  className="form-control"
                                  id="total_premium_with_tax_comprehensive"
                                  name="total_premium_with_tax_comprehensive"
                                  {...register(
                                    "total_premium_with_tax_comprehensive",
                                    {
                                      required: "This is required.",
                                    }
                                  )}
                                />
                                {errors.total_premium_with_tax_comprehensive && (
                                  <ErrorLabel
                                    message={
                                      errors
                                        .total_premium_with_tax_comprehensive
                                        ?.message
                                    }
                                  />
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        {watchQuoteType != "New" && (
                          <div className="card mt-2">
                            <div className="card-body">
                              <div className=" mb-3">
                                <div className="form-group">
                                  <label
                                    htmlFor="previous_add_on_value"
                                    className="label-control "
                                  >
                                    Previous Add-On
                                  </label>
                                  <input
                                    type="text"
                                    // onFocus={numberWheelChange}
                                    className="form-control cust-fs-12"
                                    id="previous_add_on_value"
                                    name="previous_add_on_value"
                                    {...register("previous_add_on_value", {})}
                                  />
                                  {errors.previous_add_on_value && (
                                    <ErrorLabel
                                      message={
                                        errors.previous_add_on_value?.message
                                      }
                                    />
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>

                      {/* Add on 1 */}
                      <div className="col-12 col-md-4">
                        <div className="card h-100">
                          <div className="card-header d-flex justify-content-between">
                            <h6 className="mb-0">Plan 1</h6>
                            {/* <p className="mb-0">
                        Status :{" "}
                        {initialData?.plan_1_active === "yes" ? (
                          <span className="text-success">Active</span>
                        ) : (
                          <span className="text-danger">Inactive</span>
                        )}
                      </p> */}
                          </div>
                          <div className="card-body">
                            <div className="form-group">
                              <label
                                htmlFor="add_on_1"
                                className="label-control"
                              >
                                Addon 1 %<span className="text-danger">*</span>
                              </label>
                              <input
                                type="number"
                                onFocus={numberWheelChange}
                                className="form-control"
                                id="add_on_1"
                                name="add_on_1"
                                {...register("add_on_1", {
                                  required: "This is required.",
                                })}
                              />
                              {errors.add_on_1 && (
                                <ErrorLabel
                                  message={errors.add_on_1?.message}
                                />
                              )}
                            </div>
                            <div className="form-group mt-3">
                              <label
                                htmlFor="add_on_1_premium"
                                className="label-control"
                              >
                                Addon 1 Premium
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                className="form-control"
                                id="add_on_1_premium"
                                name="add_on_1_premium"
                                {...register("add_on_1_premium", {
                                  required: "This is required.",
                                })}
                              />
                              {errors.add_on_1_premium && (
                                <ErrorLabel
                                  message={errors.add_on_1_premium?.message}
                                />
                              )}
                            </div>
                            <div className="col-12 mt-3">
                              <div className="form-group">
                                <label
                                  htmlFor="gold_extra_1"
                                  className="label-control"
                                >
                                  Gold Extra
                                </label>
                                <input
                                  className="form-control"
                                  id="gold_extra_1"
                                  name="gold_extra_1"
                                  {...register("gold_extra_1", {})}
                                />
                              </div>
                            </div>
                            <div className="form-group mt-3">
                              <label
                                htmlFor="total_od_tp_add_on_1"
                                className="label-control"
                              >
                                Total OD TP Add-On 1{" "}
                                <span className="text-danger"></span>
                              </label>
                              <input
                                className="form-control"
                                id="total_od_tp_add_on_1"
                                name="total_od_tp_add_on_1"
                                {...register("total_od_tp_add_on_1", {
                                  required: "This is required.",
                                })}
                              />
                              {errors.total_od_tp_add_on_1 && (
                                <ErrorLabel
                                  message={errors.total_od_tp_add_on_1?.message}
                                />
                              )}
                            </div>
                            <div className="form-group mt-3">
                              <label
                                htmlFor="gst_od_tp_add_on_1"
                                className="label-control"
                              >
                                GST OD TP Add-On 1{" "}
                                <span className="text-danger"></span>
                              </label>
                              <input
                                className="form-control"
                                id="gst_od_tp_add_on_1"
                                name="gst_od_tp_add_on_1"
                                {...register("gst_od_tp_add_on_1", {
                                  required: "This is required.",
                                })}
                              />
                              {errors.gst_od_tp_add_on_1 && (
                                <ErrorLabel
                                  message={errors.gst_od_tp_add_on_1?.message}
                                />
                              )}
                            </div>
                            <div className="form-group mt-3">
                              <label
                                htmlFor="total_premium_with_tax_add_on_1"
                                className="label-control"
                              >
                                Total Premium with Tax Addon 1{" "}
                                <span className="text-danger"></span>
                              </label>
                              <input
                                className="form-control"
                                id="total_premium_with_tax_add_on_1"
                                name="total_premium_with_tax_add_on_1"
                                {...register(
                                  "total_premium_with_tax_add_on_1",
                                  {
                                    required: "This is required.",
                                  }
                                )}
                              />
                              {errors.total_premium_with_tax_add_on_1 && (
                                <ErrorLabel
                                  message={
                                    errors.total_premium_with_tax_add_on_1
                                      ?.message
                                  }
                                />
                              )}
                            </div>
                            <div className="col-12 mt-3 ">
                              <div className="form-group">
                                <label
                                  htmlFor="add_on_1_remarks"
                                  className="label-control"
                                >
                                  Cops Remark Add On 1
                                </label>
                                <input
                                  className="form-control"
                                  id="add_on_1_remarks"
                                  name="add_on_1_remarks"
                                  {...register("add_on_1_remarks")}
                                />
                              </div>
                            </div>
                            {/* <div className="form-group mt-3">
                        <label
                          htmlFor="plan_1_active"
                          className="label-control"
                        >
                          Status{" "}
                          <span className="text-danger">*</span>
                        </label>
                        <select
                          className="form-control"
                          id="plan_1_active"
                          name="plan_1_active"
                          placeholder="Select..."
                          {...register("plan_1_active", {
                            required: "This is required.",
                          })}
                        >
                          <option value="yes">Active</option>
                          <option value="no">Inactive</option>
                        </select>
                        {errors.plan_1_active && (
                          <ErrorLabel message={errors.plan_1_active?.message} />
                        )}
                      </div> */}
                          </div>
                        </div>
                      </div>

                      {/* Add on 2 */}
                      <div className="col-12 col-md-4">
                        <div className="card">
                          <div className="card-header d-flex justify-content-between">
                            <h6 className="mb-0">Plan 2 </h6>
                            <p className="mb-0">
                              {/* Status :{" "} */}
                              {/* {initialData?.plan_1_active === "yes" ? (
                          <span className="text-success">Active</span>
                        ) : (
                          <span className="text-danger">Inactive</span>
                        )} */}
                            </p>
                          </div>
                          <div className="card-body">
                            <div className="form-group">
                              <label
                                htmlFor="add_on_2"
                                className="label-control"
                              >
                                Addon 2 %<span className="text-danger">*</span>
                              </label>
                              <input
                                type="number"
                                onFocus={numberWheelChange}
                                className="form-control"
                                id="add_on_2"
                                name="add_on_2"
                                {...register("add_on_2", {
                                  required: "This is required.",
                                })}
                              />
                              {errors.add_on_2 && (
                                <ErrorLabel
                                  message={errors.add_on_2?.message}
                                />
                              )}
                            </div>
                            <div className="form-group mt-3">
                              <label
                                htmlFor="add_on_2_premium"
                                className="label-control"
                              >
                                Addon 2 Premium
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                className="form-control"
                                id="add_on_2_premium"
                                name="add_on_2_premium"
                                {...register("add_on_2_premium", {
                                  required: "This is required.",
                                })}
                              />
                              {errors.add_on_2_premium && (
                                <ErrorLabel
                                  message={errors.add_on_2_premium?.message}
                                />
                              )}
                            </div>
                            <div className="col-12 mt-3 ">
                              <div className="form-group">
                                <label
                                  htmlFor="gold_extra_2"
                                  className="label-control"
                                >
                                  Gold Extra
                                </label>
                                <input
                                  className="form-control"
                                  id="gold_extra_2"
                                  name="gold_extra_2"
                                  {...register("gold_extra_2")}
                                />
                              </div>
                            </div>
                            <div className="form-group mt-3">
                              <label
                                htmlFor="total_od_tp_add_on_2"
                                className="label-control"
                              >
                                Total OD TP Add-On 2
                                <span className="text-danger"></span>
                              </label>
                              <input
                                className="form-control"
                                id="total_od_tp_add_on_2"
                                name="total_od_tp_add_on_2"
                                {...register("total_od_tp_add_on_2", {
                                  required: "This is required.",
                                })}
                              />
                              {errors.total_od_tp_add_on_2 && (
                                <ErrorLabel
                                  message={errors.total_od_tp_add_on_2?.message}
                                />
                              )}
                            </div>
                            <div className="form-group mt-3">
                              <label
                                htmlFor="gst_od_tp_add_on_2"
                                className="label-control"
                              >
                                GST OD TP Add-On 2{" "}
                                <span className="text-danger"></span>
                              </label>
                              <input
                                className="form-control"
                                id="gst_od_tp_add_on_2"
                                name="gst_od_tp_add_on_2"
                                {...register("gst_od_tp_add_on_2", {
                                  required: "This is required.",
                                })}
                              />
                              {errors.gst_od_tp_add_on_2 && (
                                <ErrorLabel
                                  message={errors.gst_od_tp_add_on_2?.message}
                                />
                              )}
                            </div>
                            <div className="form-group mt-3">
                              <label
                                htmlFor="total_premium_with_tax_add_on_2"
                                className="label-control"
                              >
                                Total Premium with Tax Addon 2
                                <span className="text-danger"></span>
                              </label>
                              <input
                                className="form-control"
                                id="total_premium_with_tax_add_on_2"
                                name="total_premium_with_tax_add_on_2"
                                {...register(
                                  "total_premium_with_tax_add_on_2",
                                  {
                                    required: "This is required.",
                                  }
                                )}
                              />
                              {errors.total_premium_with_tax_add_on_2 && (
                                <ErrorLabel
                                  message={
                                    errors.total_premium_with_tax_add_on_2
                                      ?.message
                                  }
                                />
                              )}
                            </div>
                            <div className="col-12 mt-3 ">
                              <div className="form-group">
                                <label
                                  htmlFor="add_on_2_remarks"
                                  className="label-control"
                                >
                                  Cops Remark Add On 2
                                </label>
                                <input
                                  className="form-control"
                                  id="add_on_2_remarks"
                                  name="add_on_2_remarks"
                                  {...register("add_on_2_remarks")}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/*  */}
                  </div>
                  <div className="col-6 mt-3 mb-2 h-100">
                    <div className="col-12 border-bottom mb-2">
                      <h6 className="text-primary ">
                        Recommended / Final Plan
                      </h6>
                    </div>
                    <div className="row">
                      <div className="col-12 col-md-6">
                        <div className=" card h-100">
                          <div className="card-body">
                            <div className="col-12 mb-3">
                              <div className="form-group">
                                <label
                                  htmlFor="renewal_plan_final"
                                  className="label-control"
                                >
                                  Recommended Plan{" "}
                                  <span className="text-danger"></span>
                                </label>
                                <select
                                  className="form-control"
                                  id="renewal_plan_final"
                                  name="renewal_plan_final"
                                  {...register("renewal_plan_final", {
                                    required: "This is required.",
                                  })}
                                >
                                  <option value="">Renewal Plan</option>
                                  <option value="TP Only">TP Only</option>
                                  <option value="Comprehensive">
                                    Comprehensive
                                  </option>
                                  <option value="Add_On_1">Add On 1</option>
                                  <option value="Add_On_2">Add On 2</option>
                                </select>
                                {errors.renewal_plan_final && (
                                  <ErrorLabel
                                    message={errors.renewal_plan_final?.message}
                                  />
                                )}
                              </div>
                            </div>

                            <div className="col-12 mb-3">
                              <div className="form-group">
                                <label
                                  htmlFor="renewal_final_amt"
                                  className="label-control"
                                >
                                  Renewal Final Amount{" "}
                                  <span className="text-danger"></span>
                                </label>
                                <input
                                  type="number"
                                  onFocus={numberWheelChange}
                                  className="form-control"
                                  id="renewal_final_amt"
                                  name="renewal_final_amt"
                                  {...register("renewal_final_amt", {
                                    required: "This is required.",
                                  })}
                                />
                                {errors.renewal_final_amt && (
                                  <ErrorLabel
                                    message={errors.renewal_final_amt?.message}
                                  />
                                )}
                              </div>
                            </div>

                            <div className="col-12 mb-3">
                              <div className="form-group">
                                <label
                                  htmlFor="renewal_status"
                                  className="label-control"
                                >
                                  Renewal Status{" "}
                                  <span className="text-danger"></span>
                                </label>
                                <select
                                  className="form-control"
                                  id="renewal_status"
                                  name="renewal_status"
                                  onChangeCapture={(event) => {
                                    const selectedOption =
                                      event.target.options[
                                      event.target.selectedIndex
                                      ];
                                    if (
                                      selectedOption.label === "Quote Confirm"
                                    ) {
                                      setValue(
                                        "renewal_confirm_date",
                                        moment().format("DD-MM-YYYY")
                                      );
                                    } else {
                                      setValue(
                                        "renewal_confirm_date",
                                        initialData.renewal_confirm_date !==
                                          null
                                          ? moment(
                                            initialData.renewal_confirm_date
                                          ).format("DD-MM-YYYY")
                                          : ""
                                      );
                                    }
                                  }}
                                  {...register("renewal_status", {
                                    required: "This is required.",
                                  })}
                                >
                                  <option value="Pending">Pending</option>
                                  <option value="Quote Confirm">
                                    Quote Confirm
                                  </option>
                                  <option value="Under Process">
                                    Under Process
                                  </option>
                                  <option value="Success">Success</option>
                                  <option value="Lost">Lost</option>
                                  <option value="Closed">Closed</option>
                                </select>
                                {errors.renewal_status && (
                                  <ErrorLabel
                                    message={errors.renewal_status?.message}
                                  />
                                )}
                              </div>
                            </div>

                            <div className="col-12 mb-3">
                              <div className="form-group">
                                <label
                                  htmlFor="renewal_confirm_date"
                                  className="label-control"
                                >
                                  Renewal Confirm Date{" "}
                                  <span className="text-danger"></span>
                                </label>
                                <Controller
                                  name="renewal_confirm_date"
                                  id="renewal_confirm_date"
                                  control={control}
                                  // defaultValue={watchRenewalStatus !== "Pending" ? new Date() : ''}
                                  render={({ field }) => (
                                    <Flatpickr
                                      {...field}
                                      readOnly
                                      id="disabled-picker"
                                      className="form-control"
                                      onChange={(value) => {
                                        var date = new Date(
                                          value
                                        ).toISOString();
                                        setValue(
                                          "renewal_confirm_date",
                                          moment(date).format("DD-MM-YYYY")
                                        );
                                      }}
                                      options={{
                                        dateFormat: "d-m-Y",
                                        enableTime: false,
                                      }}
                                    />
                                  )}
                                  rules={{
                                    required:
                                      watchRenewalStatus !== "Pending" &&
                                      "This is required.",
                                  }}
                                />
                                {errors.renewal_confirm_date && (
                                  <ErrorLabel
                                    message={
                                      errors.renewal_confirm_date?.message
                                    }
                                  />
                                )}
                              </div>
                            </div>

                            <div className="col-12 mb-3">
                              <div className="form-group">
                                <label className="label-control">
                                  Paid Through&nbsp;
                                  <span className="danger">*</span>
                                </label>
                                <select
                                  className="form-control"
                                  id="paid_through"
                                  name="paid_through"
                                  placeholder="Select.."
                                  {...register("paid_through", {
                                    required:
                                      watchRenewalStatus !== "Pending" &&
                                      "This is required.",
                                  })}
                                >
                                  <option value="">Select</option>
                                  <option value="Self Paid">Self Paid</option>
                                  <option value="CD Paid">CD Paid</option>
                                </select>
                                {errors.paid_through && (
                                  <ErrorLabel
                                    message={errors.paid_through?.message}
                                  />
                                )}
                              </div>
                            </div>

                            <div className="col-12 mb-3">
                              <div className="form-group">
                                <label
                                  htmlFor="cops_remarks"
                                  className="label-control"
                                >
                                  Cops Remarks{" "}
                                  <span className="text-danger"></span>
                                </label>
                                <input
                                  className="form-control"
                                  id="cops_remarks"
                                  name="cops_remarks"
                                  {...register("cops_remarks", {})}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-md-6">
                        <div className="card">
                          <div className="card-body">
                            <div className="col-12 mb-3">
                              <div className="form-group">
                                <label
                                  htmlFor="neft_received"
                                  className="label-control"
                                >
                                  NEFT Received{" "}
                                  <span className="text-danger"></span>
                                </label>
                                <select
                                  // disabled={!attachment2.length && watchRenewalStatus != "Pending"}
                                  className="form-control"
                                  id="neft_received"
                                  name="neft_received"
                                  {...register("neft_received", {
                                    required:
                                      watchRenewalStatus === "Success" &&
                                      watchPaidThrough === "Self Paid" &&
                                      "This is required.",
                                  })}
                                >
                                  {" "}
                                  {watchPaidThrough === "Self Paid" ? (
                                    <>
                                      <option value="No">No</option>
                                      <option value="Yes">Yes</option>
                                    </>
                                  ) : (
                                    <>
                                      <option value="NA">NA</option>
                                    </>
                                  )}
                                </select>
                                <p
                                  id="upload_document_first"
                                  className="d-none text-danger fs-7"
                                >
                                  If documents are not uploaded then please
                                  select NEFT status as No
                                </p>
                              </div>
                            </div>
                            <div className="col-12 mb-3">
                              <div className="form-group">
                                <label
                                  htmlFor="neft_receive_date"
                                  className="label-control"
                                >
                                  NEFT Receive Date{" "}
                                  <span className="text-danger"></span>
                                </label>
                                <Controller
                                  name="neft_receive_date"
                                  id="neft_receive_date"
                                  control={control}
                                  rules={{
                                    required:
                                      watchRenewalStatus === "Success" &&
                                      watchPaidThrough === "Self Paid" &&
                                      "This is required.",
                                  }}
                                  // rules={{}}
                                  render={({ field }) => (
                                    <Flatpickr
                                      {...field}
                                      onChange={(value) => {
                                        var date = new Date(
                                          value
                                        ).toISOString();
                                        setValue(
                                          "neft_receive_date",
                                          moment(date).format("DD-MM-YYYY")
                                        );
                                      }}
                                      id="disabled-picker"
                                      className="form-control"
                                      options={{
                                        dateFormat: "d-m-Y",
                                        enableTime: false,
                                      }}
                                    />
                                  )}
                                />
                                {errors.neft_receive_date && (
                                  <ErrorLabel
                                    message={errors.neft_receive_date?.message}
                                  />
                                )}
                              </div>
                            </div>
                            <div className="col-12 mb-3">
                              <div className="form-group">
                                <label
                                  htmlFor="neft_amount"
                                  className="label-control"
                                >
                                  NEFT Amount{" "}
                                  <span className="text-danger"></span>
                                </label>
                                <input
                                  type="number"
                                  onFocus={numberWheelChange}
                                  className="form-control"
                                  id="neft_amount"
                                  name="neft_amount"
                                  {...register("neft_amount", {
                                    required:
                                      watchRenewalStatus === "Success" &&
                                      watchPaidThrough === "Self Paid" &&
                                      "This is required.",
                                  })}
                                />
                                {errors.neft_amount && (
                                  <ErrorLabel
                                    message={errors.neft_amount?.message}
                                  />
                                )}
                              </div>
                            </div>

                            <div className="col-12 mb-3">
                              <div className="form-group">
                                <label
                                  htmlFor="neft_reference_no"
                                  className="label-control"
                                >
                                  NEFT Reference No
                                  <span className="text-danger"></span>
                                </label>
                                <input
                                  className="form-control"
                                  id="neft_reference_no"
                                  name="neft_reference_no"
                                  maxLength={100}
                                  {...register("neft_reference_no", {
                                    required:
                                      watchRenewalStatus === "Success" &&
                                      watchPaidThrough === "Self Paid" &&
                                      "This is required.",
                                    // pattern: {
                                    //   value: /^[a-zA-Z0-9]*$/,
                                    //   message: "Please enter valid number",
                                    // },
                                  })}
                                />
                                {errors.neft_reference_no && (
                                  <ErrorLabel
                                    message={errors.neft_reference_no?.message}
                                  />
                                )}
                              </div>
                            </div>

                            <div className="col-12 mb-3">
                              <div className="form-group">
                                <label
                                  htmlFor="neft_approved_cops"
                                  className="label-control"
                                >
                                  NEFT Approved Cops{" "}
                                  <span className="text-danger"></span>
                                </label>
                                <select
                                  className="form-control"
                                  id="neft_approved_cops"
                                  name="neft_approved_cops"
                                  {...register("neft_approved_cops", {})}
                                >
                                  <option value=""></option>
                                  <option value="Approved">Approved</option>
                                  <option value="Rejected">Rejected</option>
                                </select>
                              </div>
                            </div>

                            <div className="col-12 mb-3">
                              <div className="form-group">
                                <label
                                  htmlFor="neft_cops_remarks"
                                  className="label-control"
                                >
                                  NEFT Cops Remarks{" "}
                                  <span className="text-danger"></span>
                                </label>
                                <input
                                  className="form-control"
                                  id="neft_cops_remarks"
                                  name="neft_cops_remarks"
                                  {...register("neft_cops_remarks", {})}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-12 mb-2">
                <div className="col-12 border-bottom mb-2">
                  <h6 className="text-primary">Upload Document</h6>
                </div>
              </div>
              <div className="col-12 mt-1 mb-3">
                <div
                  {...getRootProps2({ className: "dropzone" })}
                  className="border-dashed text-center p-3 bg-light rounded border-secondary shadow"
                >
                  <span className="badge bg-primary rounded p-2">
                    <input accept="" name="file" {...getInputProps2()} />
                    <i className="fa fa-plus" />
                  </span>{" "}
                  <span>Add Files</span>
                </div>
                {thumbs2}
                {attachment2.length > 3 && (
                  <button
                    type="btn"
                    className="btn btn-primary rounded mt-4"
                    onClick={(e) => {
                      e.preventDefault();
                      removeAll2();
                    }}
                  >
                    Remove All
                  </button>
                )}
                {fileRejectionItems2}
              </div>
              <div className="col-12 mt-1">
                <div className="row">
                  {document && document.length > 0 && (
                    <>
                      <div className="col-12 mt-1">
                        <div className="form-group">
                          <label className="label-control mb-1">
                            Document
                          </label>
                          <div className="row">



                            {document && document.length > 0 ? (
                              document.map((objLink, index) => (
                                <>
                                  <div className="col-12 col-md-4 col-xl-3">
                                    <div className="card shadow bg-light rounded mb-1 ">
                                      <div className="card-body d-flex justify-content-between py-1">
                                        <a
                                          className="primary"
                                          onClick={() => {
                                            dispatch(actionDownload({ dmsIds: [objLink?.id] }));
                                          }}
                                        >
                                          {objLink.actual_uploaded_file_name}
                                        </a>
                                        <span className="cursor-pointer">
                                          {" "}
                                          <i
                                            size={16}
                                            className="fa fa-trash btn btn-sm primary2"
                                            onClick={() => {
                                              Swal.fire({
                                                icon: "warning",
                                                text: "Are you sure, you want to delete this document?",
                                                cancelButtonText: "Cancel",
                                                showCancelButton: true,
                                              }).then(({ isConfirmed }) => {
                                                if (isConfirmed) {
                                                  $("#progress-loader").removeClass(
                                                    "hidden"
                                                  );
                                                  // props.actionDeleteDocument({
                                                  //   policy_id:
                                                  //     proposalPoolViewDetails?.id,
                                                  //   dms_id: objLink?.id,
                                                  // });
                                                }
                                              });
                                            }}
                                          ></i>
                                        </span>
                                        <a id="downloadLink" className="d-none"></a>
                                      </div>
                                    </div>
                                  </div>
                                </>
                              ))
                            ) : (
                              <></>
                            )}
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </div>
                <div className="col-12 mt-1">
                  <div className="row">
                    {employeeDocuments && employeeDocuments.length > 0 && (
                      <>
                        <div className="col-12 mt-1">
                          <div className="form-group">
                            <label className="label-control mb-1">
                              Employee Document
                            </label>
                            <div className="row">
                              {employeeDocuments && employeeDocuments.length > 0 ? (
                                employeeDocuments.map((objLink, index) => (
                                  <>
                                    <div className="col-12 col-md-4 col-xl-3">
                                      <div className="card shadow bg-light rounded mb-1 ">
                                        <div className="card-body d-flex justify-content-between py-1">
                                          <a
                                            className="primary"
                                            onClick={() => {
                                              dispatch(
                                                actionDownload({ dmsIds: [objLink?.id] })
                                              );
                                            }}
                                          >
                                            {objLink.actual_uploaded_file_name}
                                          </a>
                                        </div>
                                      </div>
                                    </div>
                                  </>
                                ))
                              ) : (
                                <></>
                              )}
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
              <div className="form-actions border-0 float-none mt-1">
                {loading ? (
                  <button
                    id="add_edit_quote"
                    className="btn btn-primary shadow round text-uppercase me-2"
                    type="submit"
                  >
                    <div className="d-flex align-items-center">
                      Submit
                      <span
                        id="add-edit-quote-loader"
                        className="spinner-border spinner-border-sm ml-half hidden"
                      ></span>
                    </div>
                  </button>
                ) : (
                  <button
                    id="add_edit_quote"
                    className="btn btn-primary shadow round text-uppercase me-2"
                    type="submit"
                  >
                    <div className="d-flex align-items-center">Submit</div>
                  </button>
                )}
                {
                  !initialData && <button
                    className="btn btn-outline-secondary mr-1 shadow round text-uppercase"
                    onClick={(event) => {
                      event.preventDefault();
                      navigate(-1);
                    }}
                  >
                    {" "}
                    Cancel
                  </button>
                }
              </div>
            </form>
          </div>
        </div>
      </section>
    </>
  );
};

export default QuoteFrom;
